(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1482],{

/***/ 78966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ ALLOWED_TAG_LIST; },
/* harmony export */   "B": function() { return /* binding */ BANNED_TAG_LIST; },
/* harmony export */   "E": function() { return /* binding */ Element; },
/* harmony export */   "F": function() { return /* binding */ Filter; },
/* harmony export */   "M": function() { return /* binding */ Matcher; },
/* harmony export */   "T": function() { return /* binding */ TAGS; },
/* harmony export */   "a": function() { return /* binding */ ATTRIBUTES; },
/* harmony export */   "b": function() { return /* binding */ FILTER_DENY; },
/* harmony export */   "c": function() { return /* binding */ ATTRIBUTES_TO_PROPS; },
/* harmony export */   "d": function() { return /* binding */ FILTER_CAST_BOOL; },
/* harmony export */   "e": function() { return /* binding */ FILTER_CAST_NUMBER; },
/* harmony export */   "f": function() { return /* binding */ FILTER_NO_CAST; }
/* harmony export */ });
/* unused harmony exports _, g, h, i, j, k, l, m, n, o */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Bundled with Packemon: https://packemon.dev
// Platform: browser, Support: stable, Format: esm

/* eslint-disable no-bitwise, no-magic-numbers, sort-keys */
// https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories

const TYPE_FLOW = 1;
const TYPE_SECTION = 1 << 1;
const TYPE_HEADING = 1 << 2;
const TYPE_PHRASING = 1 << 3;
const TYPE_EMBEDDED = 1 << 4;
const TYPE_INTERACTIVE = 1 << 5;
const TYPE_PALPABLE = 1 << 6; // https://developer.mozilla.org/en-US/docs/Web/HTML/Element

const tagConfigs = {
  a: {
    content: TYPE_FLOW | TYPE_PHRASING,
    self: false,
    type: TYPE_FLOW | TYPE_PHRASING | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  address: {
    invalid: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'address', 'article', 'aside', 'section', 'div', 'header', 'footer'],
    self: false
  },
  audio: {
    children: ['track', 'source']
  },
  br: {
    type: TYPE_FLOW | TYPE_PHRASING,
    void: true
  },
  body: {
    content: TYPE_FLOW | TYPE_SECTION | TYPE_HEADING | TYPE_PHRASING | TYPE_EMBEDDED | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  button: {
    content: TYPE_PHRASING,
    type: TYPE_FLOW | TYPE_PHRASING | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  caption: {
    content: TYPE_FLOW,
    parent: ['table']
  },
  col: {
    parent: ['colgroup'],
    void: true
  },
  colgroup: {
    children: ['col'],
    parent: ['table']
  },
  details: {
    children: ['summary'],
    type: TYPE_FLOW | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  dd: {
    content: TYPE_FLOW,
    parent: ['dl']
  },
  dl: {
    children: ['dt', 'dd'],
    type: TYPE_FLOW
  },
  dt: {
    content: TYPE_FLOW,
    invalid: ['footer', 'header'],
    parent: ['dl']
  },
  figcaption: {
    content: TYPE_FLOW,
    parent: ['figure']
  },
  footer: {
    invalid: ['footer', 'header']
  },
  header: {
    invalid: ['footer', 'header']
  },
  hr: {
    type: TYPE_FLOW,
    void: true
  },
  img: {
    void: true
  },
  li: {
    content: TYPE_FLOW,
    parent: ['ul', 'ol', 'menu']
  },
  main: {
    self: false
  },
  ol: {
    children: ['li'],
    type: TYPE_FLOW
  },
  picture: {
    children: ['source', 'img'],
    type: TYPE_FLOW | TYPE_PHRASING | TYPE_EMBEDDED
  },
  rb: {
    parent: ['ruby', 'rtc']
  },
  rp: {
    parent: ['ruby', 'rtc']
  },
  rt: {
    content: TYPE_PHRASING,
    parent: ['ruby', 'rtc']
  },
  rtc: {
    content: TYPE_PHRASING,
    parent: ['ruby']
  },
  ruby: {
    children: ['rb', 'rp', 'rt', 'rtc']
  },
  source: {
    parent: ['audio', 'video', 'picture'],
    void: true
  },
  summary: {
    content: TYPE_PHRASING,
    parent: ['details']
  },
  table: {
    children: ['caption', 'colgroup', 'thead', 'tbody', 'tfoot', 'tr'],
    type: TYPE_FLOW
  },
  tbody: {
    parent: ['table'],
    children: ['tr']
  },
  td: {
    content: TYPE_FLOW,
    parent: ['tr']
  },
  tfoot: {
    parent: ['table'],
    children: ['tr']
  },
  th: {
    content: TYPE_FLOW,
    parent: ['tr']
  },
  thead: {
    parent: ['table'],
    children: ['tr']
  },
  tr: {
    parent: ['table', 'tbody', 'thead', 'tfoot'],
    children: ['th', 'td']
  },
  track: {
    parent: ['audio', 'video'],
    void: true
  },
  ul: {
    children: ['li'],
    type: TYPE_FLOW
  },
  video: {
    children: ['track', 'source']
  },
  wbr: {
    type: TYPE_FLOW | TYPE_PHRASING,
    void: true
  }
};

function createConfigBuilder(config) {
  return tagName => {
    tagConfigs[tagName] = { ...config,
      ...tagConfigs[tagName]
    };
  };
}

['address', 'main', 'div', 'figure', 'p', 'pre'].forEach(createConfigBuilder({
  content: TYPE_FLOW,
  type: TYPE_FLOW | TYPE_PALPABLE
}));
['abbr', 'b', 'bdi', 'bdo', 'cite', 'code', 'data', 'dfn', 'em', 'i', 'kbd', 'mark', 'q', 'ruby', 'samp', 'strong', 'sub', 'sup', 'time', 'u', 'var'].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_PHRASING | TYPE_PALPABLE
}));
['p', 'pre'].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_PALPABLE
}));
['s', 'small', 'span', 'del', 'ins'].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_PHRASING
}));
['article', 'aside', 'footer', 'header', 'nav', 'section', 'blockquote'].forEach(createConfigBuilder({
  content: TYPE_FLOW,
  type: TYPE_FLOW | TYPE_SECTION | TYPE_PALPABLE
}));
['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_HEADING | TYPE_PALPABLE
}));
['audio', 'canvas', 'iframe', 'img', 'video'].forEach(createConfigBuilder({
  type: TYPE_FLOW | TYPE_PHRASING | TYPE_EMBEDDED | TYPE_PALPABLE
})); // Disable this map from being modified

const TAGS = Object.freeze(tagConfigs); // Tags that should never be allowed, even if the allow list is disabled

const BANNED_TAG_LIST = ['applet', 'base', 'body', 'command', 'embed', 'frame', 'frameset', 'head', 'html', 'link', 'meta', 'noscript', 'object', 'script', 'style', 'title'];
const ALLOWED_TAG_LIST = Object.keys(TAGS).filter(tag => tag !== 'canvas' && tag !== 'iframe'); // Filters apply to HTML attributes

const FILTER_ALLOW = 1;
const FILTER_DENY = 2;
const FILTER_CAST_NUMBER = 3;
const FILTER_CAST_BOOL = 4;
const FILTER_NO_CAST = 5; // Attributes not listed here will be denied
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes

const ATTRIBUTES = Object.freeze({
  alt: FILTER_ALLOW,
  cite: FILTER_ALLOW,
  class: FILTER_ALLOW,
  colspan: FILTER_CAST_NUMBER,
  controls: FILTER_CAST_BOOL,
  datetime: FILTER_ALLOW,
  default: FILTER_CAST_BOOL,
  disabled: FILTER_CAST_BOOL,
  dir: FILTER_ALLOW,
  height: FILTER_ALLOW,
  href: FILTER_ALLOW,
  id: FILTER_ALLOW,
  kind: FILTER_ALLOW,
  label: FILTER_ALLOW,
  lang: FILTER_ALLOW,
  loading: FILTER_ALLOW,
  loop: FILTER_CAST_BOOL,
  media: FILTER_ALLOW,
  muted: FILTER_CAST_BOOL,
  poster: FILTER_ALLOW,
  rel: FILTER_ALLOW,
  role: FILTER_ALLOW,
  rowspan: FILTER_CAST_NUMBER,
  scope: FILTER_ALLOW,
  sizes: FILTER_ALLOW,
  span: FILTER_CAST_NUMBER,
  start: FILTER_CAST_NUMBER,
  style: FILTER_NO_CAST,
  src: FILTER_ALLOW,
  srclang: FILTER_ALLOW,
  srcset: FILTER_ALLOW,
  tabindex: FILTER_ALLOW,
  target: FILTER_ALLOW,
  title: FILTER_ALLOW,
  type: FILTER_ALLOW,
  width: FILTER_ALLOW
}); // Attributes to camel case for React props

const ATTRIBUTES_TO_PROPS = Object.freeze({
  class: 'className',
  colspan: 'colSpan',
  datetime: 'dateTime',
  rowspan: 'rowSpan',
  srclang: 'srcLang',
  srcset: 'srcSet',
  tabindex: 'tabIndex'
});

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function Element({
  attributes = {},
  className,
  children = null,
  selfClose = false,
  tagName
}) {
  const Tag = tagName;
  return selfClose ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({
    className: className
  }, attributes)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({
    className: className
  }, attributes), children);
}

class Filter {
  /**
   * Filter and clean an HTML attribute value.
   */
  attribute(name, value) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return value;
  }
  /**
   * Filter and clean an HTML node.
   */


  node(name, node) {
    return node;
  }

}
/**
 * Trigger the actual pattern match and package the matched
 * response through a callback.
 */


function match(string, pattern, process, isVoid = false) {
  const matches = string.match(pattern instanceof RegExp ? pattern : new RegExp(pattern, 'i'));

  if (!matches) {
    return null;
  }

  return {
    match: matches[0],
    void: isVoid,
    ...process(matches),
    index: matches.index,
    length: matches[0].length,
    valid: true
  };
}

class Matcher {
  constructor(name, options, factory) {
    _defineProperty(this, "greedy", false);

    _defineProperty(this, "options", void 0);

    _defineProperty(this, "propName", void 0);

    _defineProperty(this, "inverseName", void 0);

    _defineProperty(this, "factory", void 0);

    if (false) {} // @ts-expect-error Allow override


    this.options = { ...options
    };
    this.propName = name;
    this.inverseName = `no${name.charAt(0).toUpperCase() + name.slice(1)}`;
    this.factory = factory !== null && factory !== void 0 ? factory : null;
  }
  /**
   * Attempts to create a React element using a custom user provided factory,
   * or the default matcher factory.
   */


  createElement(children, props) {
    const element = this.factory ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(this.factory, props, children) : this.replaceWith(children, props);

    if (false) {}

    return element;
  }
  /**
   * Trigger the actual pattern match and package the matched
   * response through a callback.
   */


  doMatch(string, pattern, callback, isVoid = false) {
    return match(string, pattern, callback, isVoid);
  }
  /**
   * Callback triggered before parsing.
   */


  onBeforeParse(content, props) {
    return content;
  }
  /**
   * Callback triggered after parsing.
   */


  onAfterParse(content, props) {
    return content;
  }
  /**
   * Replace the match with a React element based on the matched token and optional props.
   */


}


//# sourceMappingURL=bundle-7aab7250.js.map


/***/ }),

/***/ 72423:
/***/ (function(module) {

var options = {
  startTag : "<b class='highlight'>", // could be a hyperlink
  endTag   : "</b>" // or you could use <i> instead of <b> ... want it? ask!
}
/**
 * Want to Set the Desired Start Tag to apply to the highlight?
 * see: https://github.com/dwyl/search-result-keyword-highlighter/issues/5
 * Potential future feature ...
 */

/**
 * wraps a single string passed to it in the start and end tags of the options
 * @param {String} match - the string to be wrapped
 * @returns {String} - the string wraped
 */

function wrapper (match) {
  return options.startTag + match + options.endTag;
}

/**

 * highlight does Simple String Substitution given a set of keywords in
 * a body of text and substitutes the keyword with a marked up html Tag
 * @param {String} keywords - a string of one or more keywords
 *   separated by spaces.
 * @param {String} text - the body of text where you want to highlight keywords
 * @returns {String} text - the text with all highlights.
 */
function highlight(keywords, text) {

  var regex = keywords.split(' ');
  regex = regex.filter(function(char){
    return char !== '';
  });
  regex = regex.join('|');
  regex = regex.replace(/[-[\]{}()*+?.,\\^$]/g, "\\$&");
  var matcher = new RegExp(regex, 'gi');

  return text.replace(matcher, wrapper);
}

module.exports = highlight;


/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 69572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259),
    toInteger = __webpack_require__(40554);

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 57315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93293);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n        a {\n          cursor: ",
        ";\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: #eeeeee;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n  a {\n    width: 100%;\n    height: 100%;\n  }\n  img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n  &[data-type='channel'] {\n    border-radius: 5px;\n    border: 1px solid #dddddd;\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var defaultImageSrc = {
    channel: "/static/images/channel/enterprise.png",
    user: "/static/images/channel/user-profile.png"
};
var Avatar = function(param) {
    var _type = param.type, type = _type === void 0 ? "user" : _type, src = param.src, _href = param.href, href = _href === void 0 ? "" : _href, _size = param.size, size = _size === void 0 ? 36 : _size, _enableNextImage = param.enableNextImage, enableNextImage = _enableNextImage === void 0 ? false : _enableNextImage, className = param.className;
    var defaultSrc = defaultImageSrc[type];
    var fallbackImageProps = (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .useFallbackImageInSSR */ .DN)(defaultSrc);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        "data-type": type,
        customCss: (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), size, size, href ? "pointer" : "default"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: href,
            scroll: !!href,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                children: enableNextImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    src: src || defaultSrc,
                    alt: "",
                    width: size,
                    height: size
                }, fallbackImageProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    src: src || defaultSrc,
                    alt: "avatar"
                }, fallbackImageProps))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Avatar__StyledWrapper",
    componentId: "sc-cefd5772-0"
})(_templateObject1(), function(param) {
    var customCss = param.customCss;
    return customCss;
});


/***/ }),

/***/ 35617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7029);

/* harmony default export */ __webpack_exports__["Z"] = (_Modal__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 56081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53893);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  pointer-events: ",
        ";\n\n  .page-btn {\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #eee;\n    border: none;\n    border-radius: 5px;\n    color: black;\n    svg {\n      fill: black;\n      width: 16px;\n      height: 16px;\n    }\n    &:disabled {\n      cursor: default;\n      color: white;\n      svg {\n        fill: white;\n      }\n    }\n  }\n  .page-list {\n    display: flex;\n    & > .page {\n      cursor: pointer;\n      border: none;\n      background: none;\n      padding: 10px;\n      color: #bbbbbb;\n      &[data-active='true'] {\n        color: #01a0ff;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Pagination = function(param) {
    var _type = param.type, type = _type === void 0 ? "query" : _type, className = param.className, _totalCount = param.totalCount, totalCount = _totalCount === void 0 ? 1 : _totalCount, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 1 : _pageSize, _stepSize = param.stepSize, stepSize = _stepSize === void 0 ? 10 : _stepSize, onChange = param.onChange, _value = param.value, value = _value === void 0 ? 1 : _value, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _scrollTop = param.scrollTop, scrollTop = _scrollTop === void 0 ? false : _scrollTop;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), pageState = ref[0], setPageState = ref[1];
    var currentPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (type === "value") {
            return pageState;
        } else {
            return router.query.page ? +router.query.page : 1;
        }
    }, [
        pageState,
        router.query.page
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), step = ref1[0], setStep = ref1[1];
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        setPageState(value);
        setStep(Math.ceil(value / stepSize));
    }, [
        value
    ]);
    var totalPage = Math.ceil(totalCount / pageSize);
    var stepArr = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var firstStepNumber = step * stepSize - stepSize + 1;
        var stepArr = [];
        for(var i = 0; i < stepSize; i++){
            if (firstStepNumber + i <= totalPage) stepArr.push(firstStepNumber + i);
        }
        return stepArr;
    }, [
        step,
        stepSize,
        totalPage
    ]);
    var addPage = function(page) {
        if (type === "value") {
            setPageState(page);
        }
        onChange && onChange(page);
    };
    var handleNextBtn = function() {
        setStep(function(prev) {
            return prev + 1;
        });
        addPage(step * stepSize + 1);
    };
    var handlePrevBtn = function() {
        setStep(function(prev) {
            return prev - 1;
        });
        addPage((step - 1) * stepSize - stepSize + 1);
    };
    var hasPrevStep = stepArr[0] > 1;
    var hasNextStep = stepArr[stepSize - 1] < totalPage;
    if (totalCount === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        isDisabled: isDisabled,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                className: "page-btn",
                disabled: !hasPrevStep,
                onClick: handlePrevBtn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowLeft */ .Xd, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "page-list",
                children: stepArr.map(function(page) {
                    return type === "value" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        className: "page",
                        "data-active": page === currentPage,
                        onClick: function() {
                            return addPage(page);
                        },
                        children: page
                    }, page) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: {
                            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, router.query), {
                                page: page
                            })
                        },
                        scroll: scrollTop,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "page",
                            "data-active": page === currentPage,
                            onClick: function() {
                                return addPage(page);
                            },
                            children: page
                        })
                    }, page);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                className: "page-btn",
                disabled: !hasNextStep,
                onClick: handleNextBtn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowRight */ .ol, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Pagination__StyledWrapper",
    componentId: "sc-536a0af6-0"
})(_templateObject(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "none" : "auto";
});


/***/ }),

/***/ 83821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #01a0ff;\n  text-decoration: underline;\n  margin-right: 10px;\n\n  &:hover {\n    color: #01a0ff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SnackbarLink = function(param) {
    var href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            target: "_blank",
            rel: "noreferrer",
            children: "보러가기"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SnackbarLink);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "SnackbarLink__StyledWrapper",
    componentId: "sc-264aa138-0"
})(_templateObject());


/***/ }),

/***/ 28912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            width: ",
        ";\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            left: ",
        ";\n            width: ",
        ";\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  &[data-stretch='true'] {\n    width: 100%;\n    .tab {\n      width: 100%;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  border: none;\n  background: none;\n  position: relative;\n  font-size: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  padding: 15px;\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: -0.64px;\n  color: #333;\n  &[data-active='true'] {\n    color: #01a0ff;\n    font-weight: bold;\n    .count {\n      background-color: #01a0ff;\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  height: 3px;\n  background-color: #0da0ff;\n  left: 0;\n  bottom: 0;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var LineTabs = function(param) {
    var data = param.data, initialTab = param.initialTab, className = param.className, _active = param.active, active = _active === void 0 ? true : _active, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _queryKey = param.queryKey, queryKey = _queryKey === void 0 ? "tab" : _queryKey, _type = param.type, type = _type === void 0 ? "query" : _type, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _disableGlider = param.disableGlider, disableGlider = _disableGlider === void 0 ? false : _disableGlider, _savePrevQuery = param.savePrevQuery, savePrevQuery = _savePrevQuery === void 0 ? false : _savePrevQuery, _checkTab = param.checkTab, checkTab = _checkTab === void 0 ? function() {
        return true;
    } : _checkTab;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialTab), selectedTab = ref[0], setSelectedTab = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!active) return;
        if (type === "query") {
            var selectedTabName = "".concat(router.query[queryKey]);
            var newSelectedTab = data[0];
            data.forEach(function(tab, idx) {
                var ref;
                if (tab.href && ((ref = tab.href.query) === null || ref === void 0 ? void 0 : ref[queryKey]) === selectedTabName) {
                    return newSelectedTab = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, tab), {
                        id: idx
                    });
                }
            });
            setSelectedTab(newSelectedTab);
        }
        if (type === "pathname") {
            var selectedTabName1 = "".concat(router.pathname);
            var newSelectedTab1 = data[0];
            data.forEach(function(tab, idx) {
                if (tab.href && tab.href.pathname === selectedTabName1) {
                    return newSelectedTab1 = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, tab), {
                        id: idx
                    });
                }
            });
            setSelectedTab(newSelectedTab1);
        }
    }, [
        router,
        data
    ]);
    var handleClick = function(tab) {
        if (!checkTab(tab)) return;
        if (type === "query" || type === "pathname") {
            var ref;
            var prevQuery = {};
            if (savePrevQuery) prevQuery = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, router.query);
            router.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, tab.href), {
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prevQuery, (ref = tab.href) === null || ref === void 0 ? void 0 : ref.query)
            }), undefined, {
                scroll: false
            });
        } else {
            setSelectedTab(tab);
        }
        onChange(tab.value);
    };
    var gliderX = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var _gliderX = [
            "0"
        ];
        data.reduce(function(prev, curr) {
            var sum = "";
            if (fullWidth) {
                sum = "".concat(+prev + +curr.size.slice(0, -1));
                _gliderX.push("".concat(sum, "%"));
            } else {
                var ref;
                var ref1;
                var gap = (ref1 = (ref = curr.gap) === null || ref === void 0 ? void 0 : ref.slice(0, -2)) !== null && ref1 !== void 0 ? ref1 : "0";
                sum = "".concat(+prev + +curr.size.slice(0, -2) + +gap);
                _gliderX.push("".concat(sum, "px"));
            }
            return sum;
        }, "0");
        return _gliderX;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        "data-stretch": fullWidth,
        children: [
            data.map(function(tab, idx) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Styledtab, {
                    className: "tab",
                    "data-active": (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id) === tab.id,
                    onClick: function() {
                        return handleClick(tab);
                    },
                    customCss: (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), tab.size),
                    children: tab.name
                }, idx);
            }),
            !disableGlider && selectedTab && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGlider, {
                customCss: (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject1(), (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id) && gliderX[selectedTab.id], selectedTab.size)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LineTabs);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "LineTabs__StyledWrapper",
    componentId: "sc-c8d73273-0"
})(_templateObject2(), function(param) {
    var customCss = param.customCss;
    return customCss;
});
var Styledtab = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "LineTabs__Styledtab",
    componentId: "sc-c8d73273-1"
})(_templateObject3(), function(param) {
    var customCss = param.customCss;
    return customCss;
});
var StyledGlider = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "LineTabs__StyledGlider",
    componentId: "sc-c8d73273-2"
})(_templateObject4(), function(param) {
    var customCss = param.customCss;
    return customCss;
});


/***/ }),

/***/ 94926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ component_CommunityScrapList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/search/component/LoadingListItem.tsx
var LoadingListItem = __webpack_require__(86388);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/LoadingListItem.tsx
var CoverLetterScreen_LoadingListItem = __webpack_require__(77391);
// EXTERNAL MODULE: ./src/svgIcons/ErrorIcon.tsx
var ErrorIcon = __webpack_require__(46095);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/component/CommunityScrapDeletedRow.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #cccccc;\n\n  span {\n    margin-left: 6px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CommunityScrapDeletedRow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "글쓴이가 삭제한 글입니다."
            })
        ]
    });
};
/* harmony default export */ var component_CommunityScrapDeletedRow = (CommunityScrapDeletedRow);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CommunityScrapDeletedRow__StyledWrapper",
    componentId: "sc-8bbd9a2b-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/svgIcons/CloseIcon.tsx
var CloseIcon = __webpack_require__(72398);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/component/DeleteItemButton.tsx

function DeleteItemButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  &:hover {\n    background-color: transparent;\n  }\n\n  .icon {\n    path > {\n      fill: rgba(0, 0, 0, 0.54);\n    }\n    width: 24px;\n    height: 24px;\n  }\n"
    ]);
    DeleteItemButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DeleteItemButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteItemButton_StyledWrapper, {
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
            fill: "rgba(0, 0, 0, 0.54)"
        })
    });
};
/* harmony default export */ var component_DeleteItemButton = (DeleteItemButton);
var DeleteItemButton_StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "DeleteItemButton__StyledWrapper",
    componentId: "sc-a5fdf1d0-0"
})(DeleteItemButton_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/component/CommunityScrapItem.tsx

function CommunityScrapItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 15px 8px 15px 20px;\n    "
    ]);
    CommunityScrapItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n  justify-content: space-between;\n  padding: 20px 0px;\n\n  ",
        "\n\n  .post-text {\n    font-size: 12px;\n    color: #999999;\n  }\n\n  .board-title {\n    font-size: 12px;\n    color: #333333;\n  }\n\n  .post-title {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .content-wrapper {\n    display: grid;\n    grid-template-rows: 1fr 1fr 1fr;\n  }\n  .content-header {\n    display: flex;\n    align-items: center;\n  }\n\n  .divider {\n    border: none;\n    width: 1px;\n    background-color: rgba(0, 0, 0, 0.12);\n    margin: 0px;\n    margin-left: 10px;\n    height: 13px;\n  }\n  .post-writer,\n  .post-created-at,\n  .post-views {\n    color: #999999;\n    font-size: 12px;\n  }\n\n  .post-created-at {\n    margin-left: 10px;\n  }\n  .content-body {\n    display: flex;\n\n    &:hover {\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n  .disabled {\n    display: flex;\n    &:hover {\n      text-decoration: none;\n      cursor: default;\n    }\n  }\n  .content-footer {\n    display: flex;\n    align-items: center;\n  }\n\n  .post-comment-count {\n    font-size: 16px;\n    font-weight: 500;\n    margin-left: 6px;\n  }\n  .post-views {\n    margin-left: 10px;\n  }\n  .button-wrapper {\n    display: grid;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CommunityScrapItem = function(param) {
    var node = param.node, onClickDeleteItem = param.onClickDeleteItem, onClickTitle = param.onClickTitle, className = param.className;
    var boardTitle = node.boardTitle, postCommentCount = node.postCommentCount, postCreatedAt = node.postCreatedAt, postTitle = node.postTitle, postViews = node.postViews, postWriterName = node.postWriterName, _disabledOnClickTitle = node.disabledOnClickTitle, disabledOnClickTitle = _disabledOnClickTitle === void 0 ? false : _disabledOnClickTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommunityScrapItem_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "post-writer",
                                children: postWriterName
                            }),
                            !!postCreatedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "post-created-at",
                                children: postCreatedAt
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: disabledOnClickTitle ? "disabled" : "content-body",
                        onClick: function() {
                            if (!disabledOnClickTitle) {
                                onClickTitle();
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "post-title",
                                children: postTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "post-comment-count",
                                children: postCommentCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-footer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "board-title",
                                children: boardTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "post-views",
                                children: postViews
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_DeleteItemButton, {
                    onClick: onClickDeleteItem
                })
            })
        ]
    });
};
/* harmony default export */ var component_CommunityScrapItem = (CommunityScrapItem);
var CommunityScrapItem_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CommunityScrapItem__StyledWrapper",
    componentId: "sc-1daff23c-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components_browser_esm/* css */.iv)(CommunityScrapItem_templateObject());
});

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/component/CommunityScrapList.tsx


function CommunityScrapList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .item {\n    border-bottom: 1px solid #eeeeee;\n  }\n"
    ]);
    CommunityScrapList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var CommunityScrapList = function(param) {
    var isLoading = param.isLoading, isCoverLetter = param.isCoverLetter, dataNodes = param.dataNodes, queries = param.queries;
    var ref;
    var xen = (0,context/* useDomain */.ay)().xen;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCurrentUserScrapDeleteCommunityMutation */.iB5)(), 1), deleteUserScrapCommunity = ref1[0];
    if (!dataNodes) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var communityScrapListNodes = dataNodes.map(function(node) {
        if ((node === null || node === void 0 ? void 0 : node.__typename) !== "UserScrapCommunity") {
            return null;
        }
        if (node === null || node === void 0 ? void 0 : node.post) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            var ref10;
            return {
                id: (node === null || node === void 0 ? void 0 : node.id) || "",
                boardTitle: node === null || node === void 0 ? void 0 : (ref = node.post) === null || ref === void 0 ? void 0 : (ref1 = ref.board) === null || ref1 === void 0 ? void 0 : ref1.title,
                postCommentCount: (node === null || node === void 0 ? void 0 : (ref2 = node.post) === null || ref2 === void 0 ? void 0 : ref2.commentCount) ? "[".concat(node === null || node === void 0 ? void 0 : (ref3 = node.post) === null || ref3 === void 0 ? void 0 : ref3.commentCount, "]") : undefined,
                postCreatedAt: (node === null || node === void 0 ? void 0 : (ref4 = node.post) === null || ref4 === void 0 ? void 0 : ref4.createdAt) ? (0,format/* default */.Z)(node === null || node === void 0 ? void 0 : (ref5 = node.post) === null || ref5 === void 0 ? void 0 : ref5.createdAt, "yyyy.MM.dd HH:mm") : undefined,
                postID: (node === null || node === void 0 ? void 0 : node.postID) || "",
                postTitle: (ref10 = node === null || node === void 0 ? void 0 : (ref6 = node.post) === null || ref6 === void 0 ? void 0 : ref6.title) !== null && ref10 !== void 0 ? ref10 : "rmf",
                postViews: (node === null || node === void 0 ? void 0 : (ref7 = node.post) === null || ref7 === void 0 ? void 0 : ref7.views) ? "조회 ".concat(node === null || node === void 0 ? void 0 : (ref8 = node.post) === null || ref8 === void 0 ? void 0 : ref8.views) : undefined,
                postWriterName: node === null || node === void 0 ? void 0 : (ref9 = node.post) === null || ref9 === void 0 ? void 0 : ref9.nickname
            };
        }
        return {
            id: (node === null || node === void 0 ? void 0 : node.id) || "",
            postID: (node === null || node === void 0 ? void 0 : node.postID) || "",
            postTitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_CommunityScrapDeletedRow, {}),
            disabledOnClickTitle: true
        };
    }).filter(function(node) {
        return node !== null;
    });
    var handleClickNode = function(node) {
        if ((node === null || node === void 0 ? void 0 : node.postID) && (window === null || window === void 0 ? void 0 : window.location)) {
            window.location.href = "//".concat(xen, "/community/").concat(node.postID);
        }
    };
    var handleDeleteNode = function(node) {
        if (node === null || node === void 0 ? void 0 : node.postID) {
            deleteUserScrapCommunity({
                variables: {
                    postID: node.postID
                },
                refetchQueries: queries
            });
        }
    };
    if (isLoading) {
        if (!isCoverLetter) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingListItem/* default */.Z, {
                length: 20
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterScreen_LoadingListItem/* default */.Z, {
            length: 20
        });
    }
    if (((ref = dataNodes[0]) === null || ref === void 0 ? void 0 : ref.__typename) !== "UserScrapCommunity") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityScrapList_StyledWrapper, {
        children: communityScrapListNodes.map(function(node) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_CommunityScrapItem, {
                node: node,
                onClickDeleteItem: function() {
                    return handleDeleteNode(node);
                },
                onClickTitle: function() {
                    return handleClickNode(node);
                },
                className: "item"
            }, "Community-Scrap-Item-".concat(node.id));
        })
    });
};
/* harmony default export */ var component_CommunityScrapList = (CommunityScrapList);
var CommunityScrapList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CommunityScrapList__StyledWrapper",
    componentId: "sc-80e2e852-0"
})(CommunityScrapList_templateObject());


/***/ }),

/***/ 80820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-bottom: 1px solid ",
        ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 78px 0;\n    gap: 10px;\n    .empty-title {\n      font-size: 20px;\n      font-weight: 500;\n    }\n    .empty-subtitle {\n      padding-bottom: 10px;\n      font-size: 16px;\n      font-weight: 500;\n      color: ",
        ";\n      text-align: center;\n    }\n    .move-button {\n      background: white;\n      border: none;\n      width: 189px;\n      height: 44px;\n      border-radius: 8px;\n      color: ",
        ";\n      background: ",
        ";\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 5px;\n      font-size: 14px;\n      font-weight: bold;\n      text-align: center;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var CompanyScrapEmpty = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "empty-title",
                children: "관심설정한 기업이 없습니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "empty-subtitle",
                children: [
                    "관심있는 기업을 팔로우하고, ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    " 채용소식과 합격정보를 가장 빠르게 받아보세요!"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/company-info",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                    className: "move-button",
                    children: [
                        "관심기업 설정하러 가기",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRight */ .ol, {
                            width: 14,
                            height: 14
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CompanyScrapEmpty);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CompanyScrapEmpty__StyledWrapper",
    componentId: "sc-d512a3f8-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), theme.line.line_3, theme.color.text_2, theme.background.bg_8, theme.color.primary_2);
});


/***/ }),

/***/ 11243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47079);
/* harmony import */ var _app_feature_companyInfo_constants_companyType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89064);
/* harmony import */ var components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36957);
/* harmony import */ var hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96597);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      .badge-hiring {\n        top: 12px;\n        left: 0px;\n        min-width: 37px;\n        height: 23px;\n        font-size: 11px;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: ",
        ";\n    background: ",
        ";\n    cursor: pointer;\n    padding: ",
        ";\n    position: relative;\n    border-bottom: 1px solid ",
        ";\n\n    .badge-hiring {\n      position: absolute;\n      top: 16px;\n      left: 16px;\n      background: #f46161;\n      color: ",
        ";\n      font-size: 12px;\n      font-weight: bold;\n      border-radius: 6px;\n      min-width: 44px;\n      height: 24px;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n    }\n    ",
        "\n\n    .company-logo-wrapper {\n      min-width: ",
        ";\n      padding: 0 ",
        ";\n      > img {\n        width: ",
        ";\n        height: ",
        ";\n        object-fit: contain;\n      }\n    }\n\n    .company-info-wrapper {\n      flex: 1;\n      margin-left: 12px;\n      min-width: 0;\n      .company-name {\n        font-size: ",
        ";\n        font-weight: bold;\n        line-height: 1.5;\n        letter-spacing: -0.64px;\n        margin-bottom: 4px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .company-type {\n        font-size: ",
        ";\n        line-height: 1.71;\n        letter-spacing: -0.56px;\n        margin-bottom: 8px;\n        & > span:not(:last-child)::after {\n          content: '';\n          display: inline-block;\n          vertical-align: middle;\n          margin: 0 5px;\n          width: 1px;\n          height: 10px;\n          background-color: ",
        ";\n        }\n      }\n      .company-stats {\n        font-size: 12px;\n        color: ",
        ";\n        letter-spacing: -0.48px;\n        & > span:not(:last-child)::after {\n          content: '';\n          display: inline-block;\n          vertical-align: middle;\n          margin: 0 5px;\n          width: 1px;\n          height: 10px;\n          background-color: ",
        ";\n        }\n      }\n    }\n\n    .close-btn {\n      top: 16px;\n      right: 16px;\n      font-size: 20px;\n      color: #bbb;\n      cursor: pointer;\n      background: transparent;\n      border: none;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var CompanyScrapItem = function(param) {
    var data = param.data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var enqueueApolloError = (0,hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().enqueueApolloError;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useGqlToggleCompanyInterestInMutation */ .mHt)(), 1), removeCompanyInterestedIn = ref[0];
    var handleClickCard = function() {
        router.push("/company-info/".concat(data.companyInformationId));
    };
    var handleClickDelete = function(e) {
        e.stopPropagation();
        removeCompanyInterestedIn({
            variables: {
                input: {
                    companyId: data.companyId,
                    isInterestedIn: false
                }
            },
            refetchQueries: [
                generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .GqlInterestedCompaniesDocument */ .E5A
            ],
            onError: enqueueApolloError
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        onClick: handleClickCard,
        children: [
            data.isHiring && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "badge-hiring",
                children: "채용중"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "company-logo-wrapper",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: data.companyLogo,
                    alt: data.companyName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "company-info-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                        className: "company-name",
                        children: data.companyName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "company-type",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: _app_feature_companyInfo_constants_companyType__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_TYPE_LABELS */ .w[data.companyType]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: data.industryType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "company-stats",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    "관심설정 ",
                                    (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_6__/* .getLimitNumText */ .i)({
                                        number: data.likesCount,
                                        limit: 9999
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    "조회수 ",
                                    (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_6__/* .getLimitNumText */ .i)({
                                        number: data.viewsCount,
                                        limit: 9999
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                type: "button",
                className: "close-btn",
                onClick: handleClickDelete,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .Close */ .x8, {
                    width: 15,
                    height: 15
                })
            })
        ]
    });
};
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "CompanyScrapItem__StyledWrapper",
    componentId: "sc-e2a2a5e5-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject1(), theme.isMobile ? "102px" : "125px", theme.background.bg_8, theme.isMobile ? "12px 0" : "16px", theme.line.line_3, theme.background.bg_8, theme.isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject()), theme.isMobile ? "100px" : "160px", theme.isMobile ? "8px" : "16px", theme.isMobile ? "75px" : "120px", theme.isMobile ? "48px" : "31px", theme.isMobile ? "15px" : "16px", theme.isMobile ? "13px" : "14px", theme.line.line_2, theme.color.text_2, theme.line.line_2);
});
/* harmony default export */ __webpack_exports__["Z"] = (CompanyScrapItem);


/***/ }),

/***/ 28539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53893);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85025);
/* harmony import */ var app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7029);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      max-width: 350px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 450px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n\n  .close-btn {\n    align-self: flex-end;\n    color: #999999;\n    cursor: pointer;\n  }\n  .modal-sub-title {\n    font-size: 18px;\n    margin: 20px 0 31px;\n    width: 100%;\n    text-align: center;\n    font-weight: bold;\n    span {\n      color: #01a0ff;\n    }\n  }\n  .btn-list {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    width: 100%;\n    .btn {\n      width: 100%;\n      font-size: 16px;\n      padding: 13px 30px;\n      &.cancle {\n        background-color: #bbbbbb;\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var DeleteNewsItemScrapModal = function(_param) {
    var onClose = _param.onClose, onConfirm = _param.onConfirm, totalCount = _param.totalCount, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "onClose",
        "onConfirm",
        "totalCount"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(app_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        onClose: onClose
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "close-btn",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_3__/* .Close */ .x8, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "modal-sub-title",
                    children: [
                        "잠깐, ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                            children: [
                                "스크랩한 ",
                                totalCount,
                                "건의 채널소식"
                            ]
                        }),
                        " 을 모두 삭제하실건가요?"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "btn-list",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            color: "grey",
                            className: "btn cancle",
                            onClick: onClose,
                            children: "아니요"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: "btn",
                            onClick: onConfirm,
                            children: "삭제하기"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DeleteNewsItemScrapModal);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "DeleteNewsItemScrapModal__StyledWrapper",
    componentId: "sc-bc3a353f-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)(_templateObject());
});


/***/ }),

/***/ 89749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53893);
/* harmony import */ var _app_components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85025);
/* harmony import */ var _app_components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35617);
/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68250);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 450px;\n  width: 100%;\n  min-height: 245px;\n  background-color: white;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 20px;\n\n  ",
        " {\n    max-width: 340px;\n  }\n\n  .close-button {\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    padding: 12px;\n  }\n\n  .content-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 254px;\n    position: relative;\n  }\n\n  .button-container {\n    padding: 0px 30px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    bottom: 40px;\n    gap: 8px;\n  }\n\n  .button,\n  .candle-button {\n    font-size: 16px;\n    width: 100%;\n    height: 50px;\n  }\n\n  .candle-button {\n    background-color: #eeeeee;\n    color: #333333;\n    &:hover {\n      background-color: #d5d5d5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ScrapDeleteAllModal = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "content-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "close-button",
                        onClick: props.onClose,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {
                            style: {
                                width: "16px",
                                color: "#333"
                            }
                        })
                    }),
                    props.children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "button-container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                className: "candle-button",
                                onClick: props.onClose,
                                children: "아니요"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                className: "button",
                                onClick: props.onConfirm,
                                children: "삭제하기"
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrapDeleteAllModal);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ScrapDeleteAllModal__StyledWrapper",
    componentId: "sc-528b55ac-0"
})(_templateObject(), app_styled_media__WEBPACK_IMPORTED_MODULE_5__/* .mobileBreakPoint */ .vm);


/***/ }),

/***/ 16297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j1": function() { return /* binding */ COMPANY; },
  "L_": function() { return /* binding */ COMPANY_ANALYSIS; },
  "ZP": function() { return /* binding */ ScreenScrap_mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/component/DeleteNewsItemScrapModal.tsx
var DeleteNewsItemScrapModal = __webpack_require__(28539);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/hooks/useFlutterInappwebview.ts
var useFlutterInappwebview = __webpack_require__(2165);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/screen/menus/News/NewsCardList/index.tsx + 8 modules
var NewsCardList = __webpack_require__(12035);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/mobile/screen/ScreenScrapNewsList.mobile.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .button-list {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin: 0;\n    height: 0px;\n    padding: 0 20px;\n    gap: 0px;\n    .calandar-btn,\n    .delete-btn {\n      width: inherit;\n      height: 36px;\n      transform: translate(0, -72px);\n    }\n    .calandar-btn {\n      padding: 8px 13px;\n      margin-right: 16px;\n      font-size: 12px;\n      letter-spacing: -0.2px;\n    }\n    .delete-btn {\n      width: 81.77px;\n      height: 40px;\n      font-size: 12px;\n      letter-spacing: -0.2px;\n      padding: 0 5px;\n      font-weight: 400;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ScreenScrapNewsListMobile = function(param) {
    var className = param.className;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var fluterInappwebview = (0,useFlutterInappwebview/* default */.Z)().fluterInappwebview;
    var currentPage = router.query.page ? +router.query.page : 1;
    var variables = {
        pagination: {
            page: currentPage,
            pageSize: 10
        }
    };
    var ref4 = (0,react.useState)(false), open = ref4[0], setOpen = ref4[1];
    var data = (0,graphql/* useGqlScreenScrapNewsListQuery */.OPL)({
        variables: variables,
        fetchPolicy: "cache-and-network"
    }).data;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRemoveAllScrapMutation */.Ad)(), 1), mutate = ref5[0];
    var handleConfirm = function() {
        mutate({
            refetchQueries: [
                {
                    query: graphql/* PageLayoutDocument */.TbJ,
                    variables: {
                        notificationType: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
                    }
                },
                {
                    query: graphql/* GqlUserScrapCountsDocument */.nK8
                },
                {
                    query: graphql/* GqlScreenScrapNewsListDocument */.G5G,
                    variables: variables
                }, 
            ]
        });
        if (isWebview) {
            fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveAllScraps");
        }
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "button-list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: (0,util/* getWebviewHref */.ys)("/calendar", isWebview),
                            query: {
                                activityType: "activity",
                                tab: "myActivity"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "calandar-btn",
                            color: "black",
                            variant: "outlined",
                            children: "내 스크랩 달력"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "delete-btn",
                        color: "lightGrey",
                        disabled: (data === null || data === void 0 ? void 0 : (ref = data.viewerBookmarks) === null || ref === void 0 ? void 0 : ref.totalCount) === 0,
                        onClick: function() {
                            return setOpen(true);
                        },
                        children: "모두삭제"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardList/* default */.Z, {
                totalCount: (data === null || data === void 0 ? void 0 : (ref1 = data.viewerBookmarks) === null || ref1 === void 0 ? void 0 : ref1.totalCount) || 0,
                data: data === null || data === void 0 ? void 0 : (ref2 = data.viewerBookmarks) === null || ref2 === void 0 ? void 0 : ref2.nodes.filter(function(node) {
                    return (node === null || node === void 0 ? void 0 : node.viewerHasBookmarked) === true;
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteNewsItemScrapModal/* default */.Z, {
                totalCount: data === null || data === void 0 ? void 0 : (ref3 = data.viewerBookmarks) === null || ref3 === void 0 ? void 0 : ref3.totalCount,
                open: open,
                onConfirm: handleConfirm,
                onClose: function() {
                    return setOpen(false);
                }
            })
        ]
    });
};
/* harmony default export */ var ScreenScrapNewsList_mobile = (ScreenScrapNewsListMobile);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenScrapNewsList.mobile__StyledWrapper",
    componentId: "sc-e0e05789-0"
})(_templateObject());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __webpack_require__(81763);
var isNumber_default = /*#__PURE__*/__webpack_require__.n(isNumber);
// EXTERNAL MODULE: ./src/app.feature/companyAnalysis/components/AnalysisResultItem.tsx
var AnalysisResultItem = __webpack_require__(9289);
// EXTERNAL MODULE: ./src/app.feature/companyAnalysis/components/AnalysisResultItemSkeleton.tsx
var AnalysisResultItemSkeleton = __webpack_require__(6226);
// EXTERNAL MODULE: ./src/constants/paginations.ts
var paginations = __webpack_require__(52169);
// EXTERNAL MODULE: ./src/components/Pagination.tsx
var Pagination = __webpack_require__(83740);
// EXTERNAL MODULE: ./src/screens/ScrapScreen/useScrapState.ts
var useScrapState = __webpack_require__(22874);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/component/ScrapDeleteAllModal.tsx
var ScrapDeleteAllModal = __webpack_require__(89749);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/screen/ScrapListNotFound.tsx + 1 modules
var ScrapListNotFound = __webpack_require__(36126);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/mobile/component/AnalysisScrapList.mobile.tsx




function AnalysisScrapList_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0px;\n\n  .button-box {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin: 0;\n    padding: 0 20px;\n    height: 0px;\n    gap: 0px;\n  }\n\n  .delete-button {\n    background: none;\n    border: none;\n    min-width: 50px;\n    height: 36px;\n    font-size: 14px;\n    line-height: 1.86;\n    letter-spacing: -0.56px;\n    transform: translate(0, -72px);\n    font-weight: 400;\n    color: #333;\n  }\n\n  .divider {\n    border: none;\n    height: 1px;\n    background-color: #eeeeee;\n    margin: 0px;\n  }\n  .list-wrapper {\n    padding: 0px 20px;\n  }\n\n  .calendar-button {\n    font-size: 12px;\n    letter-spacing: -0.2px;\n    width: inherit;\n    height: 36px;\n    transform: translate(0, -72px);\n    padding: 8px 13px;\n    margin-right: 16px;\n  }\n"
    ]);
    AnalysisScrapList_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  .primary-text {\n    font-size: inherit;\n    font-weight: inherit;\n    color: #01a0ff;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var AnalysisScrapListMobile = function() {
    var isWebview = (0,useIsWebview/* default */.Z)();
    var fluterInappwebview = (0,useFlutterInappwebview/* default */.Z)().fluterInappwebview;
    var context = (0,useScrapState/* useScrapStateContext */.$)();
    var ref = (0,react.useState)(false), showDeleteAlert = ref[0], setShowDeleteAlert = ref[1];
    var pagination = context.pagination, page = context.page;
    var ref1 = (0,graphql/* useGqlViewerScrappedAnalysisReportsQuery */.DQk)({
        variables: {
            pagination: {
                page: page,
                pageSize: paginations/* LIST_PAGE_SIZE */.v9
            }
        },
        fetchPolicy: "cache-and-network"
    }), data = ref1.data, loading = ref1.loading, variables = ref1.variables, error = ref1.error;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlDeleteAllAnalysisReportScrapsMutation */.yFk)(), 1), deleteAllAnalysisReportScraps = ref2[0];
    var totalCount = data === null || data === void 0 ? void 0 : data.viewerScrappedAnalysisReports.totalCount;
    if (isNumber_default()(totalCount)) {
        pagination.setNumberOfPages(Math.ceil(totalCount / paginations/* LIST_PAGE_SIZE */.v9));
        window.scrollTo(0, 0);
    }
    function handleDeleteAllUserScraps() {
        return _handleDeleteAllUserScraps.apply(this, arguments);
    }
    function _handleDeleteAllUserScraps() {
        _handleDeleteAllUserScraps = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deleteAllAnalysisReportScraps({
                                refetchQueries: [
                                    {
                                        query: graphql/* GqlUserScrapCountsDocument */.nK8
                                    },
                                    {
                                        query: graphql/* GqlViewerScrappedAnalysisReportsDocument */.axq,
                                        variables: variables
                                    }
                                ]
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (isWebview) {
                            fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveAllScraps");
                        }
                        setShowDeleteAlert(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleDeleteAllUserScraps.apply(this, arguments);
    }
    var handleShowDeleteAlert = function() {
        setShowDeleteAlert(function(prev) {
            return !prev;
        });
    };
    if (!data || (data === null || data === void 0 ? void 0 : data.viewerScrappedAnalysisReports.nodes.length) === 0 || error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapListNotFound/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnalysisScrapList_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "button-box",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "delete-button",
                            onClick: handleShowDeleteAlert,
                            children: "모두삭제"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "list-wrapper",
                        children: loading ? Array.from({
                            length: 5
                        }, function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalysisResultItemSkeleton/* default */.Z, {}, index);
                        }) : data.viewerScrappedAnalysisReports.nodes.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalysisResultItem/* default */.Z, {
                                item: item,
                                isScrapScreen: true
                            }, item.id);
                        })
                    })
                ]
            }),
            data.viewerScrappedAnalysisReports.nodes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                pagination: pagination
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapDeleteAllModal/* default */.Z, {
                open: showDeleteAlert,
                onClose: handleShowDeleteAlert,
                onConfirm: handleDeleteAllUserScraps,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteDialogContent, {
                    children: [
                        "잠깐, 스크랩한",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "primary-text",
                            children: [
                                totalCount,
                                "건의 기업분석자료"
                            ]
                        }),
                        "를",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " 모두 삭제하실건가요?"
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var AnalysisScrapList_mobile = (AnalysisScrapListMobile);
var AnalysisScrapList_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AnalysisScrapList.mobile__StyledWrapper",
    componentId: "sc-b2cc6523-0"
})(AnalysisScrapList_mobile_templateObject());
var DeleteDialogContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AnalysisScrapList.mobile__DeleteDialogContent",
    componentId: "sc-b2cc6523-1"
})(_templateObject1());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/component/CompanyScrapEmpty.tsx
var CompanyScrapEmpty = __webpack_require__(80820);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/component/CompanyScrapItem.tsx
var CompanyScrapItem = __webpack_require__(11243);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/mobile/component/CompanyScrapList.tsx







function CompanyScrapList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0px;\n\n    .button-list {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      margin: 0;\n      height: 0px;\n      padding: 0 20px;\n      gap: 0px;\n      .calandar-btn,\n      .delete-btn {\n        width: inherit;\n        height: 36px;\n        transform: translate(0, -72px);\n      }\n      .calandar-btn {\n        padding: 8px 13px;\n        margin-right: 16px;\n        font-size: 12px;\n        letter-spacing: -0.2px;\n      }\n      .delete-btn {\n        width: 81.77px;\n        height: 40px;\n        font-size: 12px;\n        letter-spacing: -0.2px;\n        padding: 0 5px;\n        font-weight: 400;\n      }\n    }\n\n    .company-scrap-list-wrapper {\n      background-color: ",
        ";\n      padding: 0 20px;\n    }\n\n    .header {\n      height: 58px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border-bottom: 1px solid ",
        ";\n\n      > label {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        font-size: 13px;\n\n        & > input[type='checkbox'] {\n          display: none;\n        }\n\n        & > span {\n          position: relative;\n          padding-left: 28px;\n          display: flex;\n          align-items: center;\n\n          .checkbox-icon {\n            position: absolute;\n            left: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 23px;\n            height: 23px;\n            border: 1.5px solid ",
        ";\n            border-radius: 5px;\n            background-color: ",
        ";\n            box-sizing: border-box;\n            transition: all 0.2s;\n          }\n        }\n\n        & > input[type='checkbox']:checked ~ span {\n          color: ",
        ";\n          font-weight: 500;\n\n          .checkbox-icon {\n            background-color: ",
        ";\n            border-color: ",
        ";\n          }\n        }\n      }\n    }\n  "
    ]);
    CompanyScrapList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyScrapList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CompanyScrapList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  .primary-text {\n    font-size: inherit;\n    font-weight: inherit;\n    color: #01a0ff;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

















var ITEMS_PER_PAGE = 20;
var CompanyScrapList = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var fluterInappwebview = (0,useFlutterInappwebview/* default */.Z)().fluterInappwebview;
    var ref1 = (0,react.useState)(false), showDeleteAlert = ref1[0], setShowDeleteAlert = ref1[1];
    var context = (0,useScrapState/* useScrapStateContext */.$)();
    var pagination = context.pagination;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlRemoveAllCompanyInterestedInMutation */.$6P)(), 1), removeAllCompanyInterestedIn = ref2[0];
    var ref3 = (0,graphql/* useGqlInterestedCompaniesQuery */.vmH)({
        variables: {
            filterBy: {
                isRecruiting: router.query.nowHiring === "true"
            },
            pagination: {
                page: Number(router.query.p) || 1,
                pageSize: 20
            }
        },
        fetchPolicy: "cache-and-network"
    }), data = ref3.data, loading = ref3.loading, error = ref3.error;
    var ref4 = (0,graphql/* useGqlInterestedCompaniesTotalCountQuery */.Gq6)({
        variables: {
            filterBy: {}
        },
        fetchPolicy: "cache-and-network"
    }), totalCountData = ref4.data;
    var totalCompanyCount = (totalCountData === null || totalCountData === void 0 ? void 0 : totalCountData.interestedCompanies.totalCount) || 0;
    var interestedCompaniesData = ((ref = data === null || data === void 0 ? void 0 : data.interestedCompanies.nodes) === null || ref === void 0 ? void 0 : ref.map(function(company) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        return {
            companyId: company.id,
            companyInformationId: ((ref = company.companyInformation) === null || ref === void 0 ? void 0 : ref.id) || "",
            companyName: ((ref1 = company.companyInformation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.company) === null || ref2 === void 0 ? void 0 : ref2.name) || "",
            companyLogo: ((ref3 = company.companyInformation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.thumbnailImage) === null || ref4 === void 0 ? void 0 : ref4.url) || "",
            isHiring: ((ref5 = company.companyInformation) === null || ref5 === void 0 ? void 0 : ref5.isRecruiting) || false,
            isLiked: ((ref6 = company.companyInformation) === null || ref6 === void 0 ? void 0 : ref6.viewerInterestedIn) || false,
            companyType: ((ref7 = company.companyInformation) === null || ref7 === void 0 ? void 0 : ref7.companyType) || "",
            industryType: ((ref8 = company.companyInformation) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.companyIndustry) === null || ref9 === void 0 ? void 0 : ref9.secondary) || "",
            likesCount: company.interestCount,
            viewsCount: company.viewCount
        };
    })) || [];
    var totalCount = (data === null || data === void 0 ? void 0 : data.interestedCompanies.totalCount) || 0;
    (0,react.useEffect)(function() {
        if (totalCount > 0) {
            var numberOfPages = Math.ceil(totalCount / ITEMS_PER_PAGE);
            pagination.setNumberOfPages(numberOfPages);
        }
    }, [
        totalCount,
        pagination
    ]);
    var deleteAllCompanyScraps = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _query, _, rest;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _query = router.query, _ = _query.p, rest = (0,_object_without_properties/* default */.Z)(_query, [
                            "p"
                        ]);
                        router.push({
                            pathname: router.pathname,
                            query: (0,_object_spread/* default */.Z)({}, rest)
                        });
                        return [
                            4,
                            removeAllCompanyInterestedIn({
                                refetchQueries: [
                                    graphql/* GqlInterestedCompaniesDocument */.E5A,
                                    graphql/* GqlUserScrapCountsDocument */.nK8
                                ]
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteAllCompanyScraps() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deleteAllCompanyScraps()
                        ];
                    case 1:
                        _state.sent();
                        setShowDeleteAlert(false);
                        if (isWebview) {
                            fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveAllScraps");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseDeleteAlert = function() {
        setShowDeleteAlert(false);
    };
    var handleClickDeleteAll = function() {
        setShowDeleteAlert(true);
    };
    var handleChangeNowHiring = function(e) {
        var _query = router.query, _ = _query.p, rest = (0,_object_without_properties/* default */.Z)(_query, [
            "p"
        ]);
        router.push({
            pathname: router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                nowHiring: e.target.checked
            })
        });
    };
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyScrapEmpty/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyScrapList_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "button-list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: (0,util/* getWebviewHref */.ys)("/calendar", isWebview),
                            query: {
                                activityType: "activity",
                                tab: "myActivity"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "calandar-btn",
                            color: "black",
                            variant: "outlined",
                            children: "내 스크랩 달력"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "delete-btn",
                        color: "lightGrey",
                        disabled: (data === null || data === void 0 ? void 0 : data.interestedCompanies.totalCount) === 0,
                        onClick: handleClickDeleteAll,
                        children: "모두삭제"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "company-scrap-list-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            htmlFor: "now-hiring-checkbox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    id: "now-hiring-checkbox",
                                    checked: router.query.nowHiring === "true",
                                    onChange: handleChangeNowHiring
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-icon",
                                            children: router.query.nowHiring === "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {
                                                width: 12,
                                                height: 9,
                                                color: "white"
                                            })
                                        }),
                                        "채용중"
                                    ]
                                })
                            ]
                        })
                    }),
                    !interestedCompaniesData.length || error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyScrapEmpty/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "list-wrapper",
                        children: loading ? Array.from({
                            length: 5
                        }, function(_, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalysisResultItemSkeleton/* default */.Z, {}, index);
                        }) : interestedCompaniesData.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyScrapItem/* default */.Z, {
                                data: item
                            }, item.companyInformationId);
                        })
                    })
                ]
            }),
            totalCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                pagination: pagination
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapDeleteAllModal/* default */.Z, {
                open: showDeleteAlert,
                onClose: handleCloseDeleteAlert,
                onConfirm: handleConfirm,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyScrapList_DeleteDialogContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "delete-modal-content",
                        children: [
                            "잠깐, 관심설정한",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "primary-text",
                                children: [
                                    " ",
                                    totalCompanyCount,
                                    "개의 기업정보"
                                ]
                            }),
                            "를",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 모두 삭제하실건가요?"
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var component_CompanyScrapList = (CompanyScrapList);
var CompanyScrapList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompanyScrapList__StyledWrapper",
    componentId: "sc-6ba55b5-0"
})(CompanyScrapList_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CompanyScrapList_templateObject(), theme.background.bg_8, theme.line.line_3, theme.line.line_2, theme.background.bg_8, theme.color.text_1, theme.color.primary_2, theme.color.primary_2);
});
var CompanyScrapList_DeleteDialogContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompanyScrapList__DeleteDialogContent",
    componentId: "sc-6ba55b5-1"
})(_templateObject2());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/screens/CoverLetterParagraphScrapScreen/CoverLetterParagraphScrapListItem.tsx + 1 modules
var CoverLetterParagraphScrapListItem = __webpack_require__(74104);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/CoverLetterList/CoverLetterListContent.tsx + 2 modules
var CoverLetterListContent = __webpack_require__(61813);
// EXTERNAL MODULE: ./src/screens/CoverLetterScreen/mobile/components/CoverLetterList/CoverLetterListItemMobile.tsx + 1 modules
var CoverLetterListItemMobile = __webpack_require__(70335);
// EXTERNAL MODULE: ./src/svgIcons/Close.tsx
var Close = __webpack_require__(43785);
// EXTERNAL MODULE: ./src/components/ActivityListItem.tsx
var ActivityListItem = __webpack_require__(23343);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/component/CommunityScrapList.tsx + 3 modules
var CommunityScrapList = __webpack_require__(94926);
// EXTERNAL MODULE: ./src/app.components/tabs/LineTabs/LineTabs.tsx
var LineTabs = __webpack_require__(28912);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/mobile/component/CoverLetterScrapListFilter.mobile.tsx

function CoverLetterScrapListFilter_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  z-index: 100;\n  .tabs-content {\n    max-width: 1148px;\n    margin: 0 auto;\n    width: 100%;\n    border-top: 1px solid #e8e8e8;\n  }\n"
    ]);
    CoverLetterScrapListFilter_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CoverLetterScrapListFilter_mobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 50px;\n"
    ]);
    CoverLetterScrapListFilter_mobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CoverLetterScrapListFilterMobile = function() {
    var setTabState = (0,useScrapState/* useScrapStateContext */.$)().setTabState;
    var tabs = [
        {
            id: 0,
            name: "전체",
            size: "100px",
            href: {
                query: {
                    tab: graphql/* UserScrapType.COVER_LETTER_AND_PARAGRAPH */.C0b.COVER_LETTER_AND_PARAGRAPH
                }
            },
            value: graphql/* UserScrapType.COVER_LETTER_AND_PARAGRAPH */.C0b.COVER_LETTER_AND_PARAGRAPH
        },
        {
            id: 1,
            name: "문장스크랩",
            size: "100px",
            href: {
                query: {
                    tab: graphql/* UserScrapType.COVER_LETTER_PARAGRAPH */.C0b.COVER_LETTER_PARAGRAPH
                }
            },
            value: graphql/* UserScrapType.COVER_LETTER_PARAGRAPH */.C0b.COVER_LETTER_PARAGRAPH
        },
        {
            id: 2,
            name: "전문스크랩",
            size: "100px",
            href: {
                query: {
                    tab: graphql/* UserScrapType.COVER_LETTER */.C0b.COVER_LETTER
                }
            },
            value: graphql/* UserScrapType.COVER_LETTER */.C0b.COVER_LETTER
        }, 
    ];
    var handleChange = function(value) {
        setTabState(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterScrapListFilter_mobile_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tabs-content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLineTabs, {
                data: tabs,
                initialTab: tabs[0],
                savePrevQuery: true,
                onChange: handleChange
            })
        })
    });
};
/* harmony default export */ var CoverLetterScrapListFilter_mobile = (CoverLetterScrapListFilterMobile);
var CoverLetterScrapListFilter_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterScrapListFilter.mobile__StyledWrapper",
    componentId: "sc-28ee8f50-0"
})(CoverLetterScrapListFilter_mobile_templateObject());
var CustomLineTabs = (0,styled_components_browser_esm/* default */.ZP)(LineTabs/* default */.Z).withConfig({
    displayName: "CoverLetterScrapListFilter.mobile__CustomLineTabs",
    componentId: "sc-28ee8f50-1"
})(CoverLetterScrapListFilter_mobile_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/mobile/component/ScrapList.mobile.tsx







function ScrapList_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0px;\n\n  .close-icon {\n    width: 16px;\n    height: 16px;\n    path {\n      fill: #333;\n    }\n  }\n  .button-box {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin: 0;\n    padding: 0 20px;\n    height: 0px;\n    gap: 0px;\n  }\n\n  .cover-letter-wrapper {\n    padding: 0px 20px;\n    background-color: #fff;\n  }\n\n  .delete-button {\n    font-size: 12px;\n    letter-spacing: -0.2px;\n    width: inherit;\n    height: 36px;\n    transform: translate(0, -72px);\n    padding: 0 5px;\n    font-weight: 400;\n  }\n\n  .divider {\n    border: none;\n    height: 1px;\n    background-color: #eeeeee;\n    margin: 0px;\n  }\n\n  .calendar-button {\n    font-size: 12px;\n    letter-spacing: -0.2px;\n    width: inherit;\n    height: 36px;\n    transform: translate(0, -72px);\n    padding: 8px 13px;\n    margin-right: 16px;\n  }\n\n  .pagination-box {\n    padding-bottom: 20px;\n  }\n\n  .webview-pagination-box {\n    padding-bottom: 70px;\n    background-color: #fafafa;\n  }\n"
    ]);
    ScrapList_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScrapList_mobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  .primary-text {\n    font-size: inherit;\n    font-weight: inherit;\n    color: #01a0ff;\n  }\n"
    ]);
    ScrapList_mobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






















var _obj;
var LabelByUserScrapType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY, "공고"), (0,_define_property/* default */.Z)(_obj, graphql/* UserScrapType.COVER_LETTER_AND_PARAGRAPH */.C0b.COVER_LETTER_AND_PARAGRAPH, "자소서와 문장"), (0,_define_property/* default */.Z)(_obj, graphql/* UserScrapType.COVER_LETTER */.C0b.COVER_LETTER, "자소서"), (0,_define_property/* default */.Z)(_obj, graphql/* UserScrapType.COVER_LETTER_PARAGRAPH */.C0b.COVER_LETTER_PARAGRAPH, "문장"), (0,_define_property/* default */.Z)(_obj, graphql/* UserScrapType.COMMUNITY */.C0b.COMMUNITY, "커뮤니티"), (0,_define_property/* default */.Z)(_obj, graphql/* UserScrapType.NEWS_ITEM */.C0b.NEWS_ITEM, "채널"), _obj);
var ScrapListMobile = function() {
    var ref, ref1;
    var isWebview = (0,useIsWebview/* default */.Z)();
    var fluterInappwebview = (0,useFlutterInappwebview/* default */.Z)().fluterInappwebview;
    var context = (0,useScrapState/* useScrapStateContext */.$)();
    var ref2 = (0,react.useState)(false), showDeleteAlert = ref2[0], setShowDeleteAlert = ref2[1];
    var tabState = context.tabState, pagination = context.pagination, page = context.page;
    var pageSize = paginations/* LIST_PAGE_SIZE */.v9;
    var ref3 = (0,graphql/* useGqlUserScrapListQuery */.kqg)({
        variables: {
            filterBy: {
                userScrapType: graphql/* UserScrapType */.C0b[tabState] || graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY
            },
            pagination: {
                page: page,
                pageSize: pageSize
            },
            orderBy: {
                field: graphql/* UserScrapOrderField.CREATED_AT */.RPx.CREATED_AT,
                direction: graphql/* OrderDirection.DESC */.N9t.DESC
            }
        },
        fetchPolicy: "cache-and-network"
    }), data = ref3.data, loading = ref3.loading, variables = ref3.variables, error = ref3.error;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUserScrapDeleteAllMutation */.X_M)(), 1), deleteAllUserScraps = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCurrentUserScrapsDeleteAllCommunityMutation */.vHh)(), 1), deleteAllUserScrapsCommunity = ref5[0];
    var queries = [
        {
            query: graphql/* GqlUserScrapListDocument */.yVC,
            variables: variables
        },
        {
            query: graphql/* GqlUserScrapCountsDocument */.nK8
        }, 
    ];
    var isCoverLetter = graphql/* UserScrapType */.C0b[tabState] !== graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY && graphql/* UserScrapType */.C0b[tabState] !== graphql/* UserScrapType.COMMUNITY */.C0b.COMMUNITY;
    var totalCount = data === null || data === void 0 ? void 0 : (ref = data.userScraps) === null || ref === void 0 ? void 0 : ref.totalCount;
    (0,react.useEffect)(function() {
        if (isNumber_default()(totalCount)) {
            pagination.setNumberOfPages(Math.ceil(totalCount / pageSize));
            window.scrollTo(0, 0);
        }
    }, [
        pageSize,
        totalCount
    ]);
    function handleDeleteAllUserScraps() {
        return _handleDeleteAllUserScraps.apply(this, arguments);
    }
    function _handleDeleteAllUserScraps() {
        _handleDeleteAllUserScraps = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(graphql/* UserScrapType */.C0b[tabState] === graphql/* UserScrapType.COMMUNITY */.C0b.COMMUNITY)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            deleteAllUserScrapsCommunity({
                                refetchQueries: queries
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            deleteAllUserScraps({
                                variables: {
                                    userScrapType: graphql/* UserScrapType */.C0b[tabState] || graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY
                                },
                                refetchQueries: queries,
                                update: function(cache, param) {
                                    var data = param.data;
                                    var ref;
                                    if (tabState === graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY || tabState === graphql/* UserScrapType.COVER_LETTER */.C0b.COVER_LETTER) {
                                        return;
                                    }
                                    var coverLetterParagraphScraps = data === null || data === void 0 ? void 0 : (ref = data.userScrapDeleteAll) === null || ref === void 0 ? void 0 : ref.coverLetterParagraphScraps;
                                    if (!coverLetterParagraphScraps) {
                                        return;
                                    }
                                    var coverLetterIDs = coverLetterParagraphScraps.map(function(scrap) {
                                        var ref;
                                        return (ref = scrap.coverLetter) === null || ref === void 0 ? void 0 : ref.id;
                                    });
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = coverLetterIDs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var coverLetterID = _step.value;
                                            if (!coverLetterID) {
                                                continue;
                                            }
                                            var cacheID = "CoverLetter:".concat(coverLetterID);
                                            var fragmentName = "CoverLetterDetailPage_coverLetter";
                                            var cachedCoverLetterFragmentData = cache.readFragment({
                                                id: cacheID,
                                                fragmentName: fragmentName,
                                                fragment: graphql/* CoverLetterDetailPage_CoverLetterFragmentDoc */.L_p
                                            });
                                            if (!cachedCoverLetterFragmentData) {
                                                continue;
                                            }
                                            cache.writeFragment({
                                                id: cacheID,
                                                fragmentName: fragmentName,
                                                fragment: graphql/* CoverLetterDetailPage_CoverLetterFragmentDoc */.L_p,
                                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedCoverLetterFragmentData), {
                                                    viewerParagraphScraps: []
                                                })
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (isWebview) {
                            fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveAllScraps");
                        }
                        setShowDeleteAlert(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handleDeleteAllUserScraps.apply(this, arguments);
    }
    var handleShowDeleteAlert = function() {
        setShowDeleteAlert(function(prev) {
            return !prev;
        });
    };
    var renderList = function() {
        var ref, ref1;
        var nodes = (data === null || data === void 0 ? void 0 : (ref = data.userScraps) === null || ref === void 0 ? void 0 : ref.nodes) || [];
        if (nodes.length === 0 || !!error) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapListNotFound/* default */.Z, {});
        }
        if (((ref1 = nodes[0]) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "UserScrapCommunity") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityScrapList/* default */.Z, {
                dataNodes: nodes,
                isCoverLetter: isCoverLetter,
                isLoading: loading,
                queries: queries
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: nodes.map(function(node) {
                if (!node || node.__typename !== "UserScrap") {
                    return;
                }
                var userScrapType = node.scrapType;
                switch(userScrapType){
                    case graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY:
                        {
                            var activity = node.activity;
                            if (!activity) {
                                return;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityListItem/* default */.Z, {
                                        size: "large",
                                        activity: activity,
                                        showActivityType: true,
                                        currentUser: data === null || data === void 0 ? void 0 : data.currentUser,
                                        scrapIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            className: "close-icon"
                                        }),
                                        showScrapCount: false,
                                        scrapRefetchQueries: queries
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "divider"
                                    })
                                ]
                            }, node.id);
                        }
                    case graphql/* UserScrapType.COVER_LETTER */.C0b.COVER_LETTER:
                        {
                            var coverLetter = node.coverLetter;
                            if (!coverLetter) {
                                return;
                            }
                            var LinkProps = (0,CoverLetterListContent/* getCoverLetterItemLinkProps */.AB)(context, coverLetter.id);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cover-letter-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterListItemMobile/* default */.Z, {
                                        coverLetter: coverLetter,
                                        currentUser: data === null || data === void 0 ? void 0 : data.currentUser,
                                        scrapIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            className: "close-icon"
                                        }),
                                        showScrapCount: false,
                                        scrapRefetchQueries: queries,
                                        LinkProps: LinkProps
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "divider"
                                    })
                                ]
                            }, node.id);
                        }
                    case graphql/* UserScrapType.COVER_LETTER_PARAGRAPH */.C0b.COVER_LETTER_PARAGRAPH:
                        {
                            var ref;
                            var coverLetterParagraphScrap = node.coverLetterParagraphScrap;
                            if (!coverLetterParagraphScrap) {
                                return;
                            }
                            var LinkProps1 = (0,CoverLetterListContent/* getCoverLetterItemLinkProps */.AB)(context, (ref = coverLetterParagraphScrap.coverLetter) === null || ref === void 0 ? void 0 : ref.id);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cover-letter-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterParagraphScrapListItem/* default */.Z, {
                                    currentUser: data === null || data === void 0 ? void 0 : data.currentUser,
                                    coverLetterParagraphScrap: coverLetterParagraphScrap,
                                    scrapRefetchQueries: queries,
                                    LinkProps: LinkProps1
                                })
                            }, node.id);
                        }
                    default:
                        {
                            break;
                        }
                }
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrapList_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "button-box",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: (0,util/* getWebviewHref */.ys)("/calendar", isWebview),
                                    query: {
                                        activityType: "activity",
                                        tab: "myActivity"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "calendar-button",
                                    color: "black",
                                    variant: "outlined",
                                    children: "내 스크랩 달력"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "delete-button",
                                color: "lightGrey",
                                disabled: (data === null || data === void 0 ? void 0 : (ref1 = data.userScraps) === null || ref1 === void 0 ? void 0 : ref1.totalCount) === 0,
                                onClick: handleShowDeleteAlert,
                                children: "모두삭제"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider"
                    }),
                    isCoverLetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterScrapListFilter_mobile, {}),
                    renderList()
                ]
            }),
            isNumber_default()(totalCount) && totalCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: isWebview ? "webview-pagination-box" : "pagination-box",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                    pagination: pagination
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapDeleteAllModal/* default */.Z, {
                open: showDeleteAlert,
                onClose: handleShowDeleteAlert,
                onConfirm: handleDeleteAllUserScraps,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrapList_mobile_DeleteDialogContent, {
                    children: [
                        "잠깐, 스크랩한",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "primary-text",
                            children: [
                                totalCount,
                                "건의 ",
                                LabelByUserScrapType[tabState]
                            ]
                        }),
                        "를",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " 모두 삭제하실건가요?"
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ScrapList_mobile = (ScrapListMobile);
var ScrapList_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrapList.mobile__StyledWrapper",
    componentId: "sc-f6017aae-0"
})(ScrapList_mobile_templateObject());
var ScrapList_mobile_DeleteDialogContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrapList.mobile__DeleteDialogContent",
    componentId: "sc-f6017aae-1"
})(ScrapList_mobile_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/mobile/component/ScrapTab.mobile.tsx

function ScrapTab_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 15px;\n  padding: 13px 20px;\n  border-bottom: 1px solid #e8e8e8;\n  background-color: #fafafa;\n  overflow-x: auto;\n  white-space: nowrap;\n  box-sizing: border-box;\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  .menu {\n    color: #999;\n    &[data-active='true'] {\n      color: black;\n    }\n  }\n"
    ]);
    ScrapTab_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ScrapTabMobile = function() {
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var tabRef = (0,react.useRef)({});
    var scrollToTabByName = function(tabName) {
        var tab = tabRef.current[tabName];
        if (tab) {
            tab.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    var scrollToTab = function(tabName) {
        return function() {
            return scrollToTabByName(tabName);
        };
    };
    var ref4 = (0,graphql/* useGqlUserScrapCountsQuery */.z0P)({
        fetchPolicy: "cache-and-network"
    }), data = ref4.data, refetch = ref4.refetch;
    (0,react.useEffect)(function() {
        refetch();
    }, [
        router.query.tab
    ]);
    var activityCounts = (data === null || data === void 0 ? void 0 : (ref = data.userScrapCounts) === null || ref === void 0 ? void 0 : ref.activityCounts) || 0;
    var companyCounts = (data === null || data === void 0 ? void 0 : (ref1 = data.userScrapCounts) === null || ref1 === void 0 ? void 0 : ref1.companyInfoCounts) || 0;
    var coverLetterCounts = (data === null || data === void 0 ? void 0 : (ref2 = data.userScrapCounts) === null || ref2 === void 0 ? void 0 : ref2.coverLetterAndParagraphCounts) || 0;
    var communityCounts = (data === null || data === void 0 ? void 0 : data.currentUserScrapsCountCommunity) || 0;
    var newsItemCounts = (data === null || data === void 0 ? void 0 : (ref3 = data.userScrapCounts) === null || ref3 === void 0 ? void 0 : ref3.newsItemCounts) || 0;
    var analysisCount = (data === null || data === void 0 ? void 0 : data.viewerScrappedAnalysisReports.totalCount) || 0;
    var tabs = [
        {
            id: 0,
            name: "공고",
            count: activityCounts,
            href: {
                query: {
                    tab: graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY
                }
            }
        },
        {
            id: 1,
            name: "관심기업",
            count: companyCounts,
            href: {
                query: {
                    tab: COMPANY
                }
            }
        },
        {
            id: 2,
            name: "합격자소서",
            count: coverLetterCounts,
            href: {
                query: {
                    tab: graphql/* UserScrapType.COVER_LETTER_AND_PARAGRAPH */.C0b.COVER_LETTER_AND_PARAGRAPH
                }
            }
        },
        {
            id: 3,
            name: "커뮤니티",
            count: communityCounts,
            href: {
                query: {
                    tab: graphql/* UserScrapType.COMMUNITY */.C0b.COMMUNITY
                }
            }
        },
        {
            id: 4,
            name: "채널소식",
            count: newsItemCounts,
            href: {
                query: {
                    tab: graphql/* UserScrapType.NEWS_ITEM */.C0b.NEWS_ITEM
                }
            }
        },
        {
            id: 5,
            name: "기업분석자료",
            count: analysisCount,
            href: {
                query: {
                    tab: COMPANY_ANALYSIS
                }
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapTab_mobile_StyledWrapper, {
        children: tabs.map(function(tab) {
            var ref, ref1;
            var _tab;
            var tabQuery = (_tab = router.query.tab) !== null && _tab !== void 0 ? _tab : graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: tab.href || "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "menu",
                    "data-active": tabQuery === ((ref = tab.href) === null || ref === void 0 ? void 0 : ref.query.tab),
                    ref: function(elem) {
                        var ref;
                        return tabRef.current[((ref = tab.href) === null || ref === void 0 ? void 0 : ref.query.tab) || ""] = elem;
                    },
                    onClick: scrollToTab(((ref1 = tab.href) === null || ref1 === void 0 ? void 0 : ref1.query.tab) || ""),
                    children: [
                        tab.name,
                        " ",
                        "(".concat(tab.count || 0, ")")
                    ]
                })
            }, tab.id);
        })
    });
};
/* harmony default export */ var ScrapTab_mobile = (ScrapTabMobile);
var ScrapTab_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrapTab.mobile__StyledWrapper",
    componentId: "sc-b6f54f5a-0"
})(ScrapTab_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/mobile/screen/ScreenScrap.mobile.tsx

function ScreenScrap_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .title-box {\n    background-color: white;\n    display: flex;\n    align-items: center;\n    padding: 13px 0px 13px 20px;\n    border-bottom: 1px solid #ddd;\n  }\n\n  .title {\n    font-weight: 700;\n    color: #333333;\n    font-size: 16px;\n    height: 24px;\n    line-height: 24px;\n    letter-spacing: -0.6px;\n  }\n\n  .tab-box {\n    position: relative;\n  }\n"
    ]);
    ScreenScrap_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var COMPANY_ANALYSIS = "COMPANY_ANALYSIS";
var COMPANY = "COMPANY";
var ScreenScrapMobile = function() {
    var router = (0,next_router.useRouter)();
    var renderScrapList = function() {
        switch(router.query.tab){
            case COMPANY:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_CompanyScrapList, {});
            case graphql/* UserScrapType.NEWS_ITEM */.C0b.NEWS_ITEM:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenScrapNewsList_mobile, {});
            case COMPANY_ANALYSIS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalysisScrapList_mobile, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapList_mobile, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScreenScrap_mobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-box",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "title",
                    children: "스크랩"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tab-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapTab_mobile, {}),
                    renderScrapList()
                ]
            })
        ]
    });
};
/* harmony default export */ var ScreenScrap_mobile = (ScreenScrapMobile);
var ScreenScrap_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenScrap.mobile__StyledWrapper",
    componentId: "sc-df87fd42-0"
})(ScreenScrap_mobile_templateObject());


/***/ }),

/***/ 36126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screen_ScrapListNotFound; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var src_context = __webpack_require__(52737);
// EXTERNAL MODULE: ./node_modules/interweave-autolink/esm/index.js
var esm = __webpack_require__(41366);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/screens/ScrapScreen/useScrapState.ts
var useScrapState = __webpack_require__(22874);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/accounts/scrap/mobile/screen/ScreenScrap.mobile.tsx + 6 modules
var ScreenScrap_mobile = __webpack_require__(16297);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/modules/getNoScrapMessage.ts


var getNoScrapMessage = function(tabState, domains) {
    switch(tabState){
        case graphql/* UserScrapType.ACTIVITY */.C0b.ACTIVITY:
            {
                return {
                    heading: {
                        highlightText: "스크랩한 공고",
                        text: "가 없습니다"
                    },
                    subText: "관심있는 공고를 확인해보시겠어요?",
                    actions: [
                        {
                            name: "대외활동",
                            link: "/list/activity"
                        },
                        {
                            name: "공모전",
                            link: "/list/contest"
                        },
                        {
                            name: "동아리",
                            link: "/list/club"
                        },
                        {
                            name: "채용",
                            link: "/list/recruit"
                        },
                        {
                            name: "교육",
                            link: "/list/education"
                        }, 
                    ]
                };
            }
        case graphql/* UserScrapType.COVER_LETTER_AND_PARAGRAPH */.C0b.COVER_LETTER_AND_PARAGRAPH:
            {
                return {
                    heading: {
                        highlightText: "스크랩한 합격자소서나 문장",
                        text: "이 없습니다"
                    },
                    subText: "합격자소서를 확인해보시겠어요?",
                    actions: [
                        {
                            name: "합격자소서보기",
                            link: "/cover-letter/search"
                        }, 
                    ]
                };
            }
        case graphql/* UserScrapType.COVER_LETTER */.C0b.COVER_LETTER:
            {
                return {
                    heading: {
                        highlightText: "스크랩한 합격자소서",
                        text: "가 없습니다"
                    },
                    subText: "합격자소서를 확인해보시겠어요?",
                    actions: [
                        {
                            name: "합격자소서보기",
                            link: "/cover-letter/search"
                        }, 
                    ]
                };
            }
        case graphql/* UserScrapType.COVER_LETTER_PARAGRAPH */.C0b.COVER_LETTER_PARAGRAPH:
            {
                return {
                    heading: {
                        highlightText: "스크랩한 문장",
                        text: "이 없습니다"
                    },
                    subText: "합격자소서를 확인해보시겠어요?",
                    actions: [
                        {
                            name: "합격자소서보기",
                            link: "/cover-letter/search"
                        }, 
                    ]
                };
            }
        case graphql/* UserScrapType.COMMUNITY */.C0b.COMMUNITY:
            {
                return {
                    heading: {
                        highlightText: "스크랩한 게시글",
                        text: "이 없습니다"
                    },
                    subText: "회원들의 실제 합격후기&인기글을 확인하시겠어요?",
                    actions: [
                        {
                            name: "Best 인기글",
                            link: "//".concat(domains.xen, "/best")
                        },
                        {
                            name: "합격후기",
                            link: "//".concat(domains.xen, "/hothot")
                        }, 
                    ]
                };
            }
        case ScreenScrap_mobile/* COMPANY_ANALYSIS */.L_:
            {
                return {
                    heading: {
                        highlightText: "스크랩한 기업분석자료",
                        text: "가 없습니다"
                    },
                    subText: "기업, 산업 등 다양한 기업분석자료를 확인해보세요",
                    actions: [
                        {
                            name: "분석자료 보러가기",
                            link: "/company-analysis"
                        }, 
                    ]
                };
            }
        default:
            {
                return {
                    heading: {
                        highlightText: "",
                        text: "잘못된 요청입니다."
                    },
                    subText: "",
                    actions: []
                };
            }
    }
};

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/screen/ScrapListNotFound.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 50vh;\n      border-top: 1px solid #eee;\n      border-bottom: 1px solid #eee;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0px;\n\n  ",
        "\n\n  .heading-text-box {\n    font-size: 20px;\n    width: 100%;\n    text-align: center;\n  }\n\n  .highlight-text {\n    color: #01a0ff;\n  }\n  .heading-text {\n    color: #333333;\n  }\n\n  .sub-text {\n    color: #999999;\n    font-size: 16px;\n    margin: 10px 0px 20px;\n  }\n  .action-button {\n    font-size: 12px;\n    padding: 11px 20px;\n    margin-left: 5px;\n    background-color: #eeeeee;\n    color: black;\n    &:hover {\n      background-color: #d5d5d5;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ScrapListNotFound = function() {
    var context = (0,useScrapState/* useScrapStateContext */.$)();
    var domains = (0,src_context/* useDomain */.ay)();
    var tabState = context.tabState;
    var ref = getNoScrapMessage(tabState, domains), heading = ref.heading, subText = ref.subText, actions = ref.actions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "heading-text-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "highlight-text ",
                        children: heading.highlightText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "heading-text",
                        children: heading.text
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "sub-text",
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: actions.map(function(action, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Link */.rU, {
                        href: action.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "action-button",
                            children: action.name
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var screen_ScrapListNotFound = (ScrapListNotFound);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrapListNotFound__StyledWrapper",
    componentId: "sc-f9a0ca75-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});


/***/ }),

/***/ 12035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ News_NewsCardList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Pagination/Pagination.tsx
var Pagination = __webpack_require__(56081);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.components/Avatar/Avatar.tsx
var Avatar = __webpack_require__(57315);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/hooks/useFlutterInappwebview.ts
var useFlutterInappwebview = __webpack_require__(2165);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
;// CONCATENATED MODULE: ./src/svgIcons/ScrapWarning.tsx

function ScrapWarning() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "aria-label": "스크랩 경고",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("desc", {
                children: "스크랩 경고"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "data-name": "그룹 4320",
                transform: "translate(-528 -740)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "12",
                        fill: "#ccc",
                        "data-name": "타원 702",
                        transform: "translate(528 740)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#fff",
                        "data-name": "그룹 4300",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M539 747h2v6h-2z",
                                "data-name": "사각형 4846"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M539 755h2v2h-2z",
                                "data-name": "사각형 4847"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var svgIcons_ScrapWarning = (ScrapWarning);

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/screen/menus/News/NewsCardList/NewsCardItem/NewsCardItem.deleted.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #eeeeee;\n  align-items: center;\n  > .lt {\n    display: flex;\n    gap: 28px;\n    overflow: hidden;\n    align-items: center;\n    .warning {\n      width: 66px;\n      height: 66px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .content {\n      color: #999999;\n    }\n  }\n  > .rt {\n    padding: 20px;\n  }\n\n  .close-btn {\n    width: 16px;\n    height: 16px;\n    fill: #333;\n  }\n\n  ",
        " {\n    > .lt {\n      padding-left: 20px;\n      gap: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// import { Close } from 'svgIcons'




var NewsCardItemDeleted = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "warning",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons_ScrapWarning, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "content",
                        children: "삭제된 소식입니다."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rt",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {
                        className: "close-btn"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var NewsCardItem_deleted = (NewsCardItemDeleted);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsCardItem.deleted__StyledWrapper",
    componentId: "sc-350a982c-0"
})(_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/screen/menus/News/NewsCardList/NewsCardItem/NewsCardItem.tsx


function NewsCardItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsCardItem_NewsItem on NewsItem {\n    id\n    viewCount\n    createdAt\n    deletedAt\n    content\n    viewerHasBookmarked\n    channel {\n      id\n      url\n      name\n      owner {\n        id\n        logoImage {\n          id\n          url\n        }\n      }\n    }\n  }\n"
    ]);
    NewsCardItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      > .lt {\n        padding-left: 20px;\n        gap: 10px;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #eeeeee;\n  align-items: center;\n  > .lt {\n    display: flex;\n    gap: 28px;\n    overflow: hidden;\n    .content {\n      overflow: hidden;\n      .channel-name {\n        display: block;\n        font-size: 12px;\n      }\n      .channel-content {\n        display: block;\n        font-size: 16px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin-bottom: 8px;\n      }\n      .channel-desc {\n        font-size: 12px;\n        color: #999;\n        span {\n          margin-right: 10px;\n        }\n      }\n    }\n  }\n\n  .close-btn {\n    cursor: pointer;\n    background: none;\n    padding: 0px;\n    border: none;\n\n    svg {\n      width: 15px;\n      height: 15px;\n    }\n  }\n  > .rt {\n    padding: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













src_default()(NewsCardItem_templateObject());
var NewsCardItem = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var isWebview = (0,useIsWebview/* default */.Z)();
    var fluterInappwebview = (0,useFlutterInappwebview/* default */.Z)().fluterInappwebview;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRemoveScrap_NewsCardItemMutation */.czz)(), 1), mutate = ref6[0];
    var handleClickRemoveBtn = function() {
        mutate({
            variables: {
                newsItemId: data.id
            },
            refetchQueries: [
                {
                    query: graphql/* PageLayoutDocument */.TbJ,
                    variables: {
                        notificationType: graphql/* NotificationScope.NOTIFICATION */.Bm0.NOTIFICATION
                    }
                },
                {
                    query: graphql/* GqlUserScrapCountsDocument */.nK8
                }, 
            ],
            onCompleted: function() {
                if (isWebview) {
                    fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveScrap");
                }
            }
        });
    };
    if (data.deletedAt !== null) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardItem_deleted, {
        onClick: handleClickRemoveBtn
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsCardItem_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        type: "channel",
                        src: (ref = data.channel) === null || ref === void 0 ? void 0 : (ref1 = ref.owner) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.logoImage) === null || ref2 === void 0 ? void 0 : ref2.url,
                        size: 66
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,util/* getWebviewHref */.ys)("/channel/".concat((ref3 = data.channel) === null || ref3 === void 0 ? void 0 : ref3.url), isWebview),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "channel-name",
                                    children: (ref4 = data.channel) === null || ref4 === void 0 ? void 0 : ref4.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,util/* getWebviewHref */.ys)("/channel/".concat((ref5 = data.channel) === null || ref5 === void 0 ? void 0 : ref5.url, "/").concat(data.id), isWebview),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "channel-content",
                                    children: data.content.replace(/<[^>]*>?/g, "")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "channel-desc",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: (0,utils/* formatDateYY_MM_DD */.w8)(data.createdAt)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rt",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "close-btn",
                    onClick: handleClickRemoveBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Close */.x8, {})
                })
            })
        ]
    });
};
/* harmony default export */ var NewsCardItem_NewsCardItem = (NewsCardItem);
var NewsCardItem_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsCardItem__StyledWrapper",
    componentId: "sc-3f68bf37-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/screen/menus/News/NewsCardList/NewsCardItem/NewsCardItemLoading.tsx

function NewsCardItemLoading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #eeeeee;\n  align-items: center;\n  > .lt {\n    display: flex;\n    gap: 28px;\n    overflow: hidden;\n    .img {\n      width: 66px;\n      height: 66px;\n      border-radius: 5px;\n      background-color: #eeeeee;\n    }\n    .content {\n      overflow: hidden;\n      .channel-name {\n        height: 12px;\n        width: 70px;\n        border-radius: 5px;\n        background-color: #eeeeee;\n        margin-bottom: 4px;\n      }\n      .channel-content {\n        height: 16px;\n        width: 200px;\n        border-radius: 5px;\n        background-color: #eeeeee;\n        margin-bottom: 8px;\n      }\n      .channel-desc {\n        height: 12px;\n        width: 100px;\n        border-radius: 5px;\n        background-color: #eeeeee;\n      }\n    }\n  }\n  > .rt {\n    padding: 20px;\n  }\n  ",
        " {\n    > .lt {\n      padding-left: 20px;\n      gap: 10px;\n    }\n  }\n"
    ]);
    NewsCardItemLoading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NewsCardItemLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsCardItemLoading_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lt",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "img"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "channel-name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "channel-content"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "channel-desc"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rt"
            })
        ]
    });
};
/* harmony default export */ var NewsCardItem_NewsCardItemLoading = (NewsCardItemLoading);
var NewsCardItemLoading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsCardItemLoading__StyledWrapper",
    componentId: "sc-ee20c996-0"
})(NewsCardItemLoading_templateObject(), media/* mobileBreakPoint */.vm);

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/screen/menus/News/NewsCardList/NewsCardItem/index.tsx


/* harmony default export */ var NewsCardList_NewsCardItem = (NewsCardItem_NewsCardItem);


// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/component/NewsCardList.empty.tsx

function NewsCardList_empty_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n  .hr {\n    height: 1px;\n    background-color: #eeeeee;\n  }\n  .empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 40px 0;\n    gap: 10px;\n    .empty-title {\n      font-size: 20px;\n      font-weight: 500;\n      span {\n        color: #01a0ff;\n      }\n    }\n    .empty-subtitle {\n      padding-bottom: 10px;\n      font-size: 16px;\n      font-weight: 500;\n      color: #999999;\n    }\n    .btn {\n      width: 82px;\n      height: 38px;\n    }\n  }\n"
    ]);
    NewsCardList_empty_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var NewsCardListEmpty = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsCardList_empty_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hr"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "empty",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "empty-title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "스크랩한 채널소식"
                            }),
                            "이 없습니다."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "empty-subtitle",
                        children: "기업들의 최신 소식을 확인하시겠어요?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/channel",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "btn",
                                color: "lightGrey",
                                children: "채널보기"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NewsCardList_empty = (NewsCardListEmpty);
var NewsCardList_empty_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsCardList.empty__StyledWrapper",
    componentId: "sc-80208200-0"
})(NewsCardList_empty_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/component/NewsCardList.loading.tsx

function NewsCardList_loading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n  .hr {\n    height: 1px;\n    background-color: #eeeeee;\n  }\n"
    ]);
    NewsCardList_loading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var NewsCardListLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsCardList_loading_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hr"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardItem_NewsCardItemLoading, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardItem_NewsCardItemLoading, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardItem_NewsCardItemLoading, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardItem_NewsCardItemLoading, {})
        ]
    });
};
/* harmony default export */ var NewsCardList_loading = (NewsCardListLoading);
var NewsCardList_loading_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsCardList.loading__StyledWrapper",
    componentId: "sc-d59965a1-0"
})(NewsCardList_loading_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/component/NewsCardList.tsx

function NewsCardList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n  .hr {\n    height: 1px;\n    background-color: #eeeeee;\n  }\n  .pg {\n    margin-top: 40px;\n  }\n"
    ]);
    NewsCardList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var NewsCardList = function(param) {
    var data = param.data, totalCount = param.totalCount;
    if (!data) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardList_loading, {});
    if (data.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardList_empty, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsCardList_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hr"
            }),
            data.map(function(node, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCardList_NewsCardItem, {
                    data: node
                }, idx);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                className: "pg",
                pageSize: 10,
                stepSize: 10,
                totalCount: totalCount
            })
        ]
    });
};
/* harmony default export */ var component_NewsCardList = (NewsCardList);
var NewsCardList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsCardList__StyledWrapper",
    componentId: "sc-4494764-0"
})(NewsCardList_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/accounts/scrap/screen/menus/News/NewsCardList/index.tsx

/* harmony default export */ var News_NewsCardList = (component_NewsCardList);


/***/ }),

/***/ 12163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ab": function() { return /* binding */ LIST_OFFSET_DEFAULT; },
/* harmony export */   "Qm": function() { return /* binding */ TEAM_RECRUIT_POST_BUTTON_VISIBLE_ACTIVITY_TYPE; },
/* harmony export */   "ep": function() { return /* binding */ TEAM_RECRUIT_VISIBLE_ACTIVITY_TYPE; },
/* harmony export */   "gH": function() { return /* binding */ CHAT_ROOM_JOINABLE_ACTIVITY_TYPE; },
/* harmony export */   "sC": function() { return /* binding */ LIST_LIMIT_DEFAULT; },
/* harmony export */   "z3": function() { return /* binding */ ACTIVITY_PAGE_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35460);

var LIST_OFFSET_DEFAULT = 0;
var LIST_LIMIT_DEFAULT = 10;
var ACTIVITY_PAGE_TYPE = constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .PageType.ACTIVITY */ .GV.ACTIVITY;
var CHAT_ROOM_JOINABLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, 
];
var TEAM_RECRUIT_VISIBLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, 
];
var TEAM_RECRUIT_POST_BUTTON_VISIBLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, 
];


/***/ }),

/***/ 89064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ COMPANY_TYPE_LABELS; }
/* harmony export */ });
var COMPANY_TYPE_LABELS = {
    ETC: "기타",
    FINANCE: "금융권",
    FOREIGN: "외국계기업",
    HOSPITAL: "병원",
    MAJOR: "대기업",
    MEDIUM: "중견기업",
    ORGANIZATION: "비영리단체/협회/재단",
    PUBLIC: "공공기관/공기업",
    SMALL_MEDIUM: "중소기업",
    STARTUP: "스타트업",
    STUDENT_ASSOCIATION: "동아리/학생자치단체"
};


/***/ }),

/***/ 86388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98913);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30132);
/* harmony import */ var svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49123);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding-left: 20px;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .container {\n    @keyframes skeleton {\n      0% {\n        opacity: 1;\n      }\n      50% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n\n    background-color: white;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    padding: 15px 10px 15px 0px;\n    ",
        "\n  }\n\n  .content-box {\n    flex-grow: 1;\n    display: flex;\n    min-width: 0px;\n    align-items: center;\n  }\n\n  .text-skeleton-box {\n    display: flex;\n    gap: 5px;\n    flex-grow: 1;\n    max-width: 100%;\n    min-width: 0%;\n    align-items: flex-start;\n    margin-right: 30px;\n    flex-direction: column;\n  }\n\n  .secondary-skeleton-box {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n  }\n\n  .skeleton-text {\n    height: 22px;\n    flex-shrink: 0;\n    transform: scale(1, 0.6);\n    border-radius: 4px;\n    display: block;\n    background-color: rgba(51, 51, 51, 0.11);\n    animation: skeleton 1.5s ease-in-out 0.5s infinite;\n  }\n\n  .skeleton-image {\n    width: 60px;\n    height: 100px;\n    margin-right: 15px;\n    flex-shrink: 0;\n    transform: scale(1, 0.6);\n    border-radius: 4px;\n    display: block;\n    background-color: rgba(51, 51, 51, 0.11);\n    animation: skeleton 1.5s ease-in-out 0.5s infinite;\n  }\n\n  .bookmark-icon {\n    width: 15px;\n    color: #e8e8e8;\n    margin: 12px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var LoadingItem = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "skeleton-image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "content-box",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "text-skeleton-box",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "skeleton-text",
                                style: {
                                    width: "100px"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "skeleton-text",
                                style: {
                                    width: "130px"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                className: "secondary-skeleton-box",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "skeleton-text",
                                        style: {
                                            width: "30px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "skeleton-text",
                                        style: {
                                            width: "30px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "skeleton-text",
                                        style: {
                                            width: "30px"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: "bookmark-icon"
                        })
                    })
                ]
            })
        ]
    });
};
var LoadingListItem = function(_param) {
    var length = _param.length, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "length"
    ]);
    var loadingItems = lodash_times__WEBPACK_IMPORTED_MODULE_3___default()(length);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: loadingItems.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
                    className: "container"
                }))
            }, item);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingListItem);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "LoadingListItem__StyledWrapper",
    componentId: "sc-dbee251d-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject());
});


/***/ }),

/***/ 91202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_components_SnackbarLink_SnackbarLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83821);
/* harmony import */ var _app_feature_activityDetail_constant_activity_constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12163);
/* harmony import */ var _app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18944);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67235);
/* harmony import */ var components_LoginAlert__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39749);
/* harmony import */ var hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38405);
/* harmony import */ var hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96597);
/* harmony import */ var hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2165);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ActivityScrap_currentUser on User {\n    id\n    scrapCount\n  }\n\n  fragment ActivityScrap_activity on Activity {\n    id\n    isScrapped\n    scrapCount\n    activityTypeID\n    manager {\n      id\n      channel {\n        id\n        url\n        viewerHasFollowed\n      }\n    }\n    chatRoom {\n      id\n      viewerIsMember\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ActivityScrap = function(props) {
    var activity = props.activity, children = props.children, refetchQueries = props.refetchQueries, update = props.update;
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_4__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var enqueueApolloError = (0,hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().enqueueApolloError;
    var joinChatRoom = (0,_app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_8__/* .useChattingContext */ .Y)().joinChatRoom;
    var fluterInappwebview = (0,hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().fluterInappwebview;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showLoginAlert = ref[0], setShowLoginAlert = ref[1];
    var user = (0,hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_11__/* .useCurrentUserContext */ .O)().user;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useActivityScrapUpdateMutation */ .ha6)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        onError: enqueueApolloError
    }, refetchQueries && {
        refetchQueries: refetchQueries,
        awaitRefetchQueries: true
    }), {
        update: update
    })), 2), activityScrapUpdate = ref1[0], loading = ref1[1].loading;
    var scrapCount = (activity === null || activity === void 0 ? void 0 : activity.scrapCount) || 0;
    var closeLoginAlert = function() {
        setShowLoginAlert(false);
    };
    var scrapActivity = function() {
        var ref, ref1, ref2;
        if (!(activity === null || activity === void 0 ? void 0 : activity.id)) {
            return;
        }
        if (!user) {
            setShowLoginAlert(true);
            return;
        }
        activityScrapUpdate({
            optimisticResponse: {
                __typename: "Mutation",
                activityScrapUpdate: {
                    __typename: "ActivityScrapUpdatePayload",
                    userScrap: {
                        id: "optimisticResponse_ID",
                        __typename: "UserScrap",
                        user: {
                            __typename: "User",
                            id: user.id,
                            scrapCount: ((user === null || user === void 0 ? void 0 : user.scrapCount) || 0) + ((activity === null || activity === void 0 ? void 0 : activity.isScrapped) ? -1 : 1),
                            scraps: []
                        }
                    },
                    activity: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, activity), {
                        id: activity.id,
                        isScrapped: !(activity === null || activity === void 0 ? void 0 : activity.isScrapped),
                        scrapCount: (activity.scrapCount || 0) + ((activity === null || activity === void 0 ? void 0 : activity.isScrapped) ? -1 : 1),
                        __typename: "Activity"
                    }),
                    scrapped: !(activity === null || activity === void 0 ? void 0 : activity.isScrapped)
                }
            },
            variables: {
                activityScrapUpdateInput: {
                    activityID: activity === null || activity === void 0 ? void 0 : activity.id,
                    referer: "/activity/".concat(activity === null || activity === void 0 ? void 0 : activity.id)
                },
                includeScrapUsers: false
            }
        });
        if (!activity.isScrapped && ((ref = activity.chatRoom) === null || ref === void 0 ? void 0 : ref.id) && _app_feature_activityDetail_constant_activity_constant__WEBPACK_IMPORTED_MODULE_7__/* .CHAT_ROOM_JOINABLE_ACTIVITY_TYPE.includes */ .gH.includes((activity === null || activity === void 0 ? void 0 : activity.activityTypeID) || -1)) {
            joinChatRoom(activity.chatRoom.id, activity.chatRoom.viewerIsMember);
        }
        if (!activity.isScrapped && ((ref1 = activity.manager) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.channel) === null || ref2 === void 0 ? void 0 : ref2.viewerHasFollowed) === false) {
            enqueueSnackbar("이 게시글을 등록한 기업을 팔로우했습니다.", {
                action: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_SnackbarLink_SnackbarLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    href: "/channel/".concat(activity.manager.channel.url)
                })
            });
        }
        // 스크랩을 모두 하나의 api에서 처리하기 때문에 스크랩 페이지에서 단건 삭제시에만 호출하도록 합니다
        if (isWebview) {
            activity.isScrapped ? fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveScrap") : fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportAddScrap");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            children({
                loading: loading,
                scrapActivity: scrapActivity,
                scrapCount: scrapCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_LoginAlert__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                DialogProps: {
                    open: showLoginAlert
                },
                onRequestClose: closeLoginAlert
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActivityScrap);
graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject());


/***/ }),

/***/ 76318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);








var useStyle = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
    return {
        greyButton: {
            color: "white",
            backgroundColor: "#bbbbbb",
            "&:hover": {
                boxShadow: "none",
                backgroundColor: "#aaaaaa"
            },
            "&:focus": {
                boxShadow: "none"
            }
        }
    };
});
var Button = function(props) {
    var classesProp = props.classes, className = props.className, tmp = props.color, colorProp = tmp === void 0 ? "default" : tmp, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "classes",
        "className",
        "color"
    ]);
    var classes = useStyle();
    var color = colorProp === "grey" ? "default" : colorProp;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        color: color
    }, buttonProps), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, classes.greyButton, colorProp === "grey"), className),
        disableElevation: true,
        classes: classesProp
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 65155:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    INVALID_REQUEST: "올바르지 않은 요청 입니다.",
    NO_RESPONSE_ERROR: "현재 서버에 응답이 없습니다. 잠시후 다시 시도해주세요",
    UNKNOWN_ERROR: "알 수 없는 오류가 발생했습니다.",
    FORBIDDEN: "요청할 수 있는 권한이 없습니다.",
    UNAUTHENTICATED: "계정이 인증되지 않았습니다. 로그인 확인 후 다시 시도해 보세요.",
    REQUIRED_LOGGED_IN: "로그인 후 사용할 수 있습니다.",
    NOT_FOUND_ERROR: "알 수 없는 오류가 발생했습니다.",
    ALREADY_EXISTING_EMAIL: "이미 가입된 이메일 입니다. 다른 이메일을 사용해주세요",
    ALREADY_EXISTING_NICKNAME: "이미 가입된 닉네임 입니다. 다른 닉네임을 사용해주세요",
    ALREADY_EXISTING_PHONE_NUMBER: "입력하신 휴대폰 번호는 이미 가입된 회원입니다.",
    INVALID_PHONE_NUMBER_FORMAT: "번호를 올바르게 입력해주세요",
    INVALID_AUTH_CODE: "인증번호가 일치하지 않습니다. 다시 확인해주세요.",
    ALREADY_JOINED_CHAT_ROOM: "이미 참여한 채팅방입니다.",
    TIMESPREAD_STATUS_REQUIRE_PARAMETER: "필요 파리미터 누락",
    TIMESPREAD_STATUS_OBJECT_NOT_EXIST: "일치하는 대상 없음",
    TIMESPREAD_STATUS_PHONE_ALREADY_AUTHORIZE: "이미 인증된 핸드폰 번호입니다.",
    TIMESPREAD_STATUS_PHONE_CODE_REQUEST_EXCEED: "휴대폰 인증 코드 요청 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_CODE_DATA_NOT_FOUND: "휴대폰 인증 코드 데이터 없음",
    TIMESPREAD_STATUS_PHONE_FAIL_AUTHORIZE: "휴대폰 인증에 실패 하였습니다.",
    TIMESPREAD_STATUS_PHONE_REQUEST_EXCEED: "휴대폰 인증 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_NOT_ACCEPTED_IP: "허용되지 않은 IP",
    TIMESPREAD_STATUS_PHONE_USER_DELETE: "탈퇴 후 7일 이후부터 휴대폰 인증 가능",
    TIMESPREAD_STATUS_LUCKYBOX_LIMIT_EXCEED: "행운상자 개수 초과",
    TIMESPREAD_STATUS_LUCKYBOX_NEED_CASH: "행운상자 도전 최소 캐시 필요",
    TIMESPREAD_STATUS_LUCKYBOX_ALREADY_OPEN: "이미 오픈된 상자",
    TIMESPREAD_STATUS_SCREEN_ALREADY_FINISH: "이미 종료된 꽉 잠금 모드"
});


/***/ }),

/***/ 44191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47079);
/* harmony import */ var _useCurrentUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38405);




function useAuthRoute(props) {
    var _role = props.role, role = _role === void 0 ? "user" : _role, _redirectPath = props.redirectPath, redirectPath = _redirectPath === void 0 ? "/" : _redirectPath, _showAlert = props.showAlert, showAlert = _showAlert === void 0 ? true : _showAlert, _skip = props.skip, skip = _skip === void 0 ? false : _skip;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), pass = ref[0], setPass = ref[1];
    var ref1 = (0,_useCurrentUser__WEBPACK_IMPORTED_MODULE_3__/* .useCurrentUserContext */ .O)(), user = ref1.user, loading = ref1.loading, error = ref1.error;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var redirect = function redirect(path) {
            if (path === "/") {
                window.location.href = "/";
                return;
            }
            router.replace(path);
        };
        if ( false || pass || loading || error || skip) return;
        if (user === null || user === void 0 ? void 0 : user.isSuperuser) {
            setPass(true);
            return;
        }
        if (role === "user" && !user) {
            if (showAlert) {
                alert("로그인 후 이용할 수 있습니다");
            }
            redirect(redirectPath);
            return;
        }
        if (role === "organization" && (user === null || user === void 0 ? void 0 : user.type) !== generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .UserType.MANAGER_UNVERIFIED */ .FWD.MANAGER_UNVERIFIED) {
            if (showAlert) {
                alert("기업회원만 이용할 수 있습니다");
            }
            redirect(redirectPath);
            return;
        }
        if (role === "admin" && !(user === null || user === void 0 ? void 0 : user.isSuperuser)) {
            if (showAlert) {
                alert("접근 권한이 없습니다");
            }
            redirect(redirectPath);
            return;
        }
        setPass(true);
    }, [
        role,
        redirectPath,
        pass,
        loading,
        error,
        user,
        showAlert,
        skip,
        router
    ]);
    return {
        pass: pass
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useAuthRoute);


/***/ }),

/***/ 96597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29229);


function useErrorSnackbar() {
    var enqueueApolloError = function enqueueApolloError(error) {
        enqueueSnackbar((0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorMessage */ .e$)(error), {
            // @ts-ignore
            "data-testid": "snackbar-apollo-error",
            // @ts-ignore
            "data-error-code": (0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorCode */ .zg)(error)
        });
    };
    var enqueueErrorMessage = function enqueueErrorMessage(message) {
        enqueueSnackbar(message, {
            // @ts-ignore
            "data-testid": "snackbar-message-error"
        });
    };
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    return {
        enqueueApolloError: enqueueApolloError,
        enqueueErrorMessage: enqueueErrorMessage
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useErrorSnackbar);


/***/ }),

/***/ 74104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CoverLetterParagraphScrapScreen_CoverLetterParagraphScrapListItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/svgIcons/CircularProgress.tsx
var CircularProgress = __webpack_require__(77396);
// EXTERNAL MODULE: ./src/svgIcons/Close.tsx
var Close = __webpack_require__(43785);
// EXTERNAL MODULE: ./src/utils/coverLetter.ts
var utils_coverLetter = __webpack_require__(5126);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/hooks/useErrorSnackbar.ts
var useErrorSnackbar = __webpack_require__(96597);
;// CONCATENATED MODULE: ./src/screens/CoverLetterParagraphScrapScreen/CoverLetterParagraphScrapDelete.tsx






var CoverLetterParagraphScrapDelete = function(props) {
    var deleteCoverLetterParagraphScrap = function deleteCoverLetterParagraphScrap() {
        if (!(coverLetterParagraphScrap === null || coverLetterParagraphScrap === void 0 ? void 0 : coverLetterParagraphScrap.id)) {
            return;
        }
        if (!currentUser) {
            return;
        }
        coverLetterParagraphScrapDelete({
            optimisticResponse: {
                __typename: "Mutation",
                coverLetterParagraphScrapDelete: {
                    __typename: "CoverLetterParagraphScrapDeletePayload",
                    userScrap: {
                        __typename: "UserScrap",
                        id: "optimisticResponse_ID",
                        user: {
                            __typename: "User",
                            id: currentUser.id,
                            scrapCount: ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.scrapCount) || 0) - 1
                        }
                    },
                    coverLetterParagraphScrap: {
                        __typename: "CoverLetterParagraphScrap",
                        id: coverLetterParagraphScrap.id,
                        paragraph: coverLetterParagraphScrap.paragraph
                    }
                }
            },
            variables: {
                id: coverLetterParagraphScrap.id
            },
            update: function(cache, param) {
                var data = param.data;
                var ref, ref1;
                var deletedCoverLetterParagraphScrapID = data === null || data === void 0 ? void 0 : (ref = data.coverLetterParagraphScrapDelete) === null || ref === void 0 ? void 0 : (ref1 = ref.coverLetterParagraphScrap) === null || ref1 === void 0 ? void 0 : ref1.id;
                if (deletedCoverLetterParagraphScrapID) {
                    var coverLetter = coverLetterParagraphScrap === null || coverLetterParagraphScrap === void 0 ? void 0 : coverLetterParagraphScrap.coverLetter;
                    if (!coverLetter) {
                        return;
                    }
                    var cacheID = "CoverLetter:".concat(coverLetter.id);
                    var fragmentName = "CoverLetterDetailPage_coverLetter";
                    var cachedCoverLetterFragmentData = cache.readFragment({
                        id: cacheID,
                        fragmentName: fragmentName,
                        fragment: graphql/* CoverLetterDetailPage_CoverLetterFragmentDoc */.L_p
                    });
                    if (!cachedCoverLetterFragmentData) {
                        return;
                    }
                    var newScraps = cachedCoverLetterFragmentData.viewerParagraphScraps.filter(function(scrap) {
                        return scrap.id !== deletedCoverLetterParagraphScrapID;
                    });
                    cache.writeFragment({
                        id: cacheID,
                        fragmentName: fragmentName,
                        fragment: graphql/* CoverLetterDetailPage_CoverLetterFragmentDoc */.L_p,
                        data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedCoverLetterFragmentData), {
                            viewerParagraphScraps: newScraps
                        })
                    });
                }
            }
        });
    };
    var currentUser = props.currentUser, coverLetterParagraphScrap = props.coverLetterParagraphScrap, children = props.children, refetchQueries = props.refetchQueries;
    var enqueueApolloError = (0,useErrorSnackbar/* default */.Z)().enqueueApolloError;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCoverLetterParagraphScrapDeleteMutation */.dVZ)((0,_object_spread/* default */.Z)({
        onError: enqueueApolloError
    }, refetchQueries && {
        refetchQueries: refetchQueries,
        awaitRefetchQueries: true
    })), 2), coverLetterParagraphScrapDelete = ref[0], loading = ref[1].loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children({
            loading: loading,
            deleteCoverLetterParagraphScrap: deleteCoverLetterParagraphScrap
        })
    });
};
/* harmony default export */ var CoverLetterParagraphScrapScreen_CoverLetterParagraphScrapDelete = (CoverLetterParagraphScrapDelete);

;// CONCATENATED MODULE: ./src/screens/CoverLetterParagraphScrapScreen/CoverLetterParagraphScrapListItem.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CoverLetterParagraphScrapListItem_coverLetterParagraphScrap on CoverLetterParagraphScrap {\n    id\n    paragraph\n    coverLetter {\n      id\n      organizationName\n      role\n      passedAt\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    padding: 20px 0;\n    border-bottom: 1px solid ",
        ";\n\n    @media (max-width: 600px) {\n      padding: 16px 0;\n    }\n\n    .link {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      font-size: 16px;\n      font-weight: normal;\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    .cover-letter-infos {\n      display: flex;\n      @media (max-width: 600px) {\n        display: none;\n      }\n    }\n\n    .content {\n      font-size: 12px;\n      font-weight: normal;\n      color: ",
        ";\n\n      @media (min-width: 601px) {\n        font-size: 16px;\n        color: inherit;\n      }\n    }\n\n    .passed-at {\n      margin-left: 10px;\n      margin-right: 20px;\n      width: 100px;\n      text-align: center;\n    }\n\n    .organization-name {\n      margin-right: 20px;\n      text-align: center;\n      width: 100px;\n    }\n\n    .role {\n      margin-right: 36px;\n      text-align: center;\n      width: 100px;\n    }\n\n    .content-wrapper {\n      margin-right: 32px;\n      flex-grow: 1;\n      display: block;\n      min-width: 0;\n      flex-direction: row;\n      letter-spacing: -0.64px;\n    }\n\n    .paragraph-scrap-badge {\n      align-self: flex-start;\n      font-size: 12px;\n      font-weight: bold;\n      padding: 4px 12px;\n      border-radius: 5px;\n      margin-bottom: 5px;\n      background-color: ",
        ";\n      display: inline-flex;\n      align-items: center;\n      height: 30px;\n\n      @media (max-width: 600px) {\n        height: 20px;\n      }\n    }\n\n    .ellipsis {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n\n    .close-icon-wrapper {\n      padding-bottom: 5px;\n      text-align: center;\n      margin-right: 10px;\n\n      @media (max-width: 600px) {\n        padding-left: 20px;\n        margin-right: 0;\n      }\n\n      button {\n        padding: 12px;\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &:disabled {\n          cursor: not-allowed;\n          opacity: 0.5;\n        }\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var CoverLetterParagraphScrapListItem = function(param) {
    var currentUser = param.currentUser, coverLetterParagraphScrap = param.coverLetterParagraphScrap, scrapRefetchQueries = param.scrapRefetchQueries, _LinkProps = param.LinkProps, LinkProps = _LinkProps === void 0 ? {
        href: "/",
        naked: true
    } : _LinkProps;
    var paragraph = coverLetterParagraphScrap.paragraph, coverLetter = coverLetterParagraphScrap.coverLetter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "link"
            }, LinkProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cover-letter-infos",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "passed-at",
                                children: (0,utils_coverLetter/* getPassedAtText */.S)(coverLetter)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ellipsis organization-name",
                                children: coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.organizationName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ellipsis role",
                                children: coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.role
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "paragraph-scrap-badge",
                                children: "문장 스크랩"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "content",
                                children: paragraph
                            })
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "close-icon-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterParagraphScrapScreen_CoverLetterParagraphScrapDelete, {
                    coverLetterParagraphScrap: coverLetterParagraphScrap,
                    currentUser: currentUser,
                    refetchQueries: scrapRefetchQueries,
                    children: function(param) {
                        var deleteCoverLetterParagraphScrap = param.deleteCoverLetterParagraphScrap, loading = param.loading;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: deleteCoverLetterParagraphScrap,
                            disabled: loading,
                            children: !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                className: "close-icon"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                width: 18,
                                height: 18,
                                color: "#01a0ff"
                            })
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var CoverLetterParagraphScrapScreen_CoverLetterParagraphScrapListItem = (CoverLetterParagraphScrapListItem);
src_default()(_templateObject());
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CoverLetterParagraphScrapListItem__StyledWrapper",
    componentId: "sc-aa63d1c7-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.line.line_3, theme.color.text_3, theme.background.bg_1);
});


/***/ }),

/***/ 77391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53450);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41120);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98913);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96679);
/* harmony import */ var svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49123);













var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            backgroundColor: "white",
            padding: "20px 0",
            width: "100%",
            borderBottom: "1px solid #fafafa"
        },
        flexWrapper: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        scrapButton: {
            color: "#e8e8e8"
        },
        bookmarkIcon: {
            width: 15
        },
        basicInfo: {
            width: 100,
            marginRight: 25,
            flexShrink: 0,
            alignItems: "center",
            display: "flex"
        },
        specInfo: {
            marginRight: 3.75,
            marginBottom: 0.5,
            width: "100%",
            flexGrow: 0,
            flexShrink: 0
        },
        content: {
            marginRight: 3.75,
            marginBottom: 0.5,
            marginTop: 5,
            width: "100%",
            flexGrow: 1
        },
        contentWrapper: {
            mr: 3.75,
            flexGrow: 1,
            display: "flex",
            minWidth: 0,
            maxWidth: "100%",
            flexDirection: "column",
            alignItems: "flex-start"
        },
        mobileSkeleton: {
            marginBottom: 5
        },
        scrapIcon: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            flexShrink: 0,
            marginLeft: 55
        }, theme.breakpoints.down("sm"), {
            marginLeft: 10
        })
    };
});
var LoadingItem = function(param) {
    var className = param.className, _variant = param.variant, variant = _variant === void 0 ? "auto" : _variant;
    var classes = useStyles();
    var columnTimes = lodash_times__WEBPACK_IMPORTED_MODULE_2___default()(4);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(classes.root, classes.flexWrapper, className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    smDown: variant === "auto" || variant === "mobile",
                    mdUp: variant === "mobile",
                    implementation: "css",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.flexWrapper,
                        children: [
                            columnTimes.map(function(column) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    className: classes.basicInfo,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        width: 100
                                    })
                                }, column);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                flexGrow: 1,
                                display: "flex",
                                minWidth: 0,
                                alignItems: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    className: classes.contentWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: classes.specInfo,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                height: 16,
                                                width: 350
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: classes.content,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                height: 70,
                                                width: 500
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    mdUp: variant === "auto" || variant === "pc",
                    implementation: "css",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.flexWrapper,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            display: "block",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    width: 200,
                                    height: 20,
                                    className: classes.mobileSkeleton
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    width: 250,
                                    height: 20,
                                    className: classes.mobileSkeleton
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    width: 280,
                                    height: 35,
                                    className: classes.mobileSkeleton
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: classes.scrapIcon,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        className: classes.scrapButton,
                        disabled: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: classes.bookmarkIcon
                        })
                    })
                })
            ]
        })
    });
};
var LoadingListItem = function(_param) {
    var length = _param.length, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "length"
    ]);
    var lodingItems = lodash_times__WEBPACK_IMPORTED_MODULE_2___default()(length);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: lodingItems.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoadingItem, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props))
            }, item);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingListItem);


/***/ }),

/***/ 22874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useScrapStateContext; },
/* harmony export */   "R": function() { return /* binding */ ScrapStateContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8920);
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11521);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17563);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);
/* harmony import */ var constants_paginations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52169);
/* harmony import */ var hooks_usePagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27914);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55208);










function initializeState(newState, updatedState) {
    if (!Object.keys(updatedState).includes("p")) {
        newState.p = 1;
    }
    return newState;
}
function useScrapState(props) {
    var handleScrapStateChange = function handleScrapStateChange(updatedState) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, scrapState, query_string__WEBPACK_IMPORTED_MODULE_0__.parse(window.location.search), updatedState);
        newState = initializeState(newState, updatedState);
        newState = (0,utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseValues */ .c6)(newState, {
            parseNumbers: true
        });
        if (onScrapStateChange) {
            onScrapStateChange(newState);
        }
    };
    var setTabState = function setTabState(newTabState) {
        handleScrapStateChange({
            tab: newTabState
        });
    };
    var setActivePage = function setActivePage(newActivePage) {
        handleScrapStateChange({
            p: newActivePage
        });
    };
    var ref = props || {}, scrapState = ref.scrapState, onScrapStateChange = ref.onScrapStateChange;
    var theme = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var isSMDown = (0,_material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.down("sm"));
    var pagination = (0,hooks_usePagination__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        activePage: (scrapState === null || scrapState === void 0 ? void 0 : scrapState.p) || 1,
        setActivePage: setActivePage,
        maxButtons: isSMDown ? constants_paginations__WEBPACK_IMPORTED_MODULE_7__/* .MOBILE_BUTTON_SIZE */ .zw : constants_paginations__WEBPACK_IMPORTED_MODULE_7__/* .PC_BUTTON_SIZE */ .lW
    });
    return {
        tabState: (scrapState === null || scrapState === void 0 ? void 0 : scrapState.tab) || generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .UserScrapType.ACTIVITY */ .C0b.ACTIVITY,
        setTabState: setTabState,
        page: (scrapState === null || scrapState === void 0 ? void 0 : scrapState.p) || 1,
        pagination: pagination
    };
}
var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,constate__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(useScrapState), 2);
var ScrapStateContextProvider = ref[0], useScrapStateContext = ref[1];


/***/ }),

/***/ 77396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes rotateProgress {\n    0% {\n      transform-origin: 50% 50%;\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes circularProgress {\n    0% {\n      stroke-dasharray: 1px, 200px;\n      stroke-dashoffset: 0px;\n    }\n    50% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -15px;\n    }\n    100% {\n      stroke-dasharray: 100px, 200px;\n      stroke-dashoffset: -125px;\n    }\n  }\n\n  width: fit-content;\n  height: fit-content;\n  animation: rotateProgress 1.4s linear infinite;\n\n  svg {\n    display: block;\n\n    circle {\n      animation: circularProgress 1.4s ease-in-out infinite;\n      stroke: currentColor;\n      stroke-dasharray: 80px, 200px;\n      stroke-dashoffset: 0px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CircularProgress = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            viewBox: "22 22 44 44",
            "aria-label": "회전로딩",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                cx: "44",
                cy: "44",
                r: "20.2",
                fill: "none",
                strokeWidth: "3.6"
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CircularProgress);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    displayName: "CircularProgress__StyledWrapper",
    componentId: "sc-4fbccb26-0"
})(_templateObject());


/***/ }),

/***/ 46095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var ErrorIcon = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
            fill: "black"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorIcon);


/***/ }),

/***/ 29229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e$": function() { return /* binding */ getErrorMessage; },
/* harmony export */   "zg": function() { return /* binding */ getErrorCode; }
/* harmony export */ });
/* unused harmony export getErrorMessageFromServer */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65155);


var getErrorCode = function(error) {
    var errorCode = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, "graphQLErrors[0].extensions.code", "UNKNOWN_ERROR");
    return errorCode;
};
var getErrorMessage = function(error) {
    var errorCode = getErrorCode(error);
    var message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(_constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, errorCode, _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"].UNKNOWN_ERROR */ .Z.UNKNOWN_ERROR);
    return message;
};
var getErrorMessageFromServer = function(error) {
    var message = get(error, "graphQLErrors[0].message", errorMessages.UNKNOWN_ERROR);
    return message;
};


/***/ })

}]);